<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button> -->
    <div class="analysisReport_box" id="pdfPrint">
      <!-- PDF  首页 -->
      <div class="HomePage">
        <!-- 图片 -->
        <div id="image"></div>
        <!-- 正文 -->
        <div id="PdfTitle">
          <p id="FristTitle">国家职业教育智慧教育平台专业与课程服务中心</p>
          <!-- <p id="SecondTitle" v-if="this.$route.query.endDay == '2022-12-31'">建设与应用监测月度分析报告</p>
          <p id="SecondTitle" v-else>建设与应用监测月度分析报告</p> -->
          <div>
            <p id="SecondTitle" v-show="this.$route.query.type == 1">建设与应用监测月度分析报告</p>
            <p id="SecondTitle" v-show="this.$route.query.type == 2">建设与应用监测季度分析报告</p>
            <p id="SecondTitle" v-show="this.$route.query.type == 3">建设与应用监测年度分析报告</p>
          </div>
          <p id="ThrendTitle" v-show="this.$route.query.type == 1">
            （{{ nowYear }}年{{ nowMonth }}月）
          </p>
          <p id="ThrendTitle" v-show="this.$route.query.type == 2">
            （{{ nowYear }}年{{ Quarter }}）
          </p>
          <p id="SecondTitle" v-show="this.$route.query.type == 3">（{{ nowYear }}年）</p>

          <p id="FourTitle">
            运行分析起止时间：{{ this.$route.query.startDay }} 至 {{ this.$route.query.endDay }}
          </p>
        </div>
        <!-- 底部 -->
        <div id="foot">
          <p>国家职业教育智慧教育平台专业与课程服务中心监测平台项目组</p>
          <p>教育大数据应用技术国家工程研究中心</p>
          <p>
            <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
            <span v-else>{{ +nowYear + 1 }}年</span>
            <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
            ><span v-else>1</span> 月 10 日
          </p>
        </div>
      </div>

      <div style="height: 450px"></div>
      <!-- 目录 -->
      <div class="catalogue" style="padding-left: 10%">
        <div class="title">
          <p>目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</p>
        </div>

        <!-- 第一部分盒子 -->
        <div class="Frist">
          <!-- 第一块区域 -->
          <h5 class="title_text">
            1.
            监测总览.................................................................................................................................................1
          </h5>
          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              1.1
              总体建设及应用分析....................................................................................................................1
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.1.1
                用户建设及应用................................................................................................................1
              </h5>
              <h5>
                1.1.2
                课程建设及应用................................................................................................................1
              </h5>
              <h5>
                1.1.3
                资源建设及应用................................................................................................................2
              </h5>
            </div>
          </div>

          <div class="Second_text">
            <h5 style="text-indent: 1.8em">
              1.2
              各省市建设及应用情况分析........................................................................................................4
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.2.1
                各省用户建设及应用........................................................................................................4
              </h5>
              <h5>
                1.2.2
                各省课程建设及应用........................................................................................................5
              </h5>
              <h5>
                1.2.3
                各省资源建设及应用........................................................................................................6
              </h5>
            </div>
          </div>

          <div class="Thred_text">
            <h5 style="text-indent: 1.8em">
              1.3 {{ this.$route.query.startDay }} 至
              {{
                this.$route.query.endDay
              }}整体运行情况分析...............................................................................6
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.3.1
                用户运行情况.....................................................................................................................6
              </h5>
              <h5>
                1.3.2
                课程运行情况.....................................................................................................................7
              </h5>
              <h5>
                1.3.3
                资源运行情况.....................................................................................................................7
              </h5>
            </div>
          </div>
        </div>

        <!-- 第二部分盒子 -->
        <div class="Second">
          <h5>
            2.专业教学资源库应用分析.......................................................................................................................8
          </h5>
          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              2.1
              资源库建设及应用情况.................................................................................................................8
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                2.1.1
                用户建设及应用情况.........................................................................................................8
              </h5>
              <h5>
                2.1.2
                课程建设及应用情况.........................................................................................................9
              </h5>
              <h5>
                2.1.3
                资源建设及应用情况.........................................................................................................10
              </h5>
              <h5>
                2.1.4
                国家级资源库应用情况分析.............................................................................................10
              </h5>
            </div>
          </div>

          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              2.2.
              各省利用资源库开展教学总体情况............................................................................................11
            </h5>
            <div style="text-indent: 7.69em">
              <h5>
                2.2.1
                各省用户建设及应用..........................................................................................................11
              </h5>
              <h5>
                2.2.2
                各省课程建设及应用..........................................................................................................12
              </h5>
              <h5>
                2.2.3
                各省资源建设及应用..........................................................................................................13
              </h5>
            </div>
          </div>

          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              2.3. {{ this.$route.query.startDay }} 至
              {{
                this.$route.query.endDay
              }}资源库运行情况分析...........................................................................13
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                2.3.1
                资源库用户运行情况..........................................................................................................13
              </h5>
              <h5>
                2.3.2
                资源库课程运行情况..........................................................................................................15
              </h5>
              <h5>
                2.3.3
                资源库资源运行情况..........................................................................................................15
              </h5>
            </div>
          </div>
        </div>

        <div style="height: 600px"></div>
        <!-- 第三部分盒子 -->
        <div class="Third">
          <h5>
            3.
            在线精品课应用分析...............................................................................................................................16
          </h5>
          <div class="Frist_text">
            <!-- <p>3.1 在线精品课建设及应用情况....................................................................................................16</p> -->
            <div class="div" style="text-indent: 1.8em">
              <h5>
                3.1
                在线精品课建设情况..........................................................................................................................16
              </h5>
              <h5>
                3.2
                在线精品课访问情况..........................................................................................................................17
              </h5>
              <h5>
                3.3
                在线精品课开课情况..........................................................................................................................17
              </h5>
              <h5>
                3.4
                在线精品课选课情况..........................................................................................................................17
              </h5>
            </div>
          </div>
        </div>

        <!-- 第四部分盒子 -->
        <div class="Fourth">
          <h5>
            4.
            视频公开课应用分析...............................................................................................................................18
          </h5>
          <div class="Frist_text">
            <!-- <p>4.1 视频公开课建设及应用情况....................................................................................................18</p> -->
            <div class="div" style="text-indent: 1.8em">
              <h5>
                4.1
                视频公开课建设情况..........................................................................................................................18
              </h5>
              <h5>
                4.2
                视频公开课访问情况..........................................................................................................................18
              </h5>
              <h5>
                4.3
                视频公开课选课情况..........................................................................................................................19
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 1800px" v-if="this.$route.query.endDay != '2022-11-30'"></div>
      <div style="height: 1852px" v-else></div>

      <div class="header_titles">
        <h1 style="margin-top: 60px">国家职业教育智慧教育平台专业与课程服务中心</h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 1">
          {{ nowYear }}年{{ nowMonth }}月建设与应用监测分析报告
        </h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 2">
          {{ nowYear }}年{{ Quarter }}建设与应用监测分析报告
        </h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 3">
          {{ nowYear }}年建设与应用监测分析报告
        </h1>

        <div class="number_time">
          <div>
            <span></span>
            <span
              >统计时间：{{ this.$route.query.startDay }} 至 {{ this.$route.query.endDay }}</span
            >
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <div class="chart_box">
        <h3>1. 监测总览</h3>
        <div style="height: 20px"></div>
        <p>
          自2022年03月28日开始，国家职业教育智慧教育平台专业与课程服务中心上线，专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对专业教学资源库、
          在线精品课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>
          截至2022年{{ nowMonth }}月{{ nowDay }}日，监测平台共接入专业教学资源库{{
            resourceLevel.total
          }}个，在线精品课{{ dataAll.dataList.onlineCourseNum }}门，视频公开课{{
            dataAll.dataList.videoCourseNum
          }}门， 覆盖平台数有{{ dataAll.dataList.platForm }}个，专业与课程服务中心累计用户访问量达{{
            dataAll.dataList.totalVisitNum > 1000000000
              ? (dataAll.dataList.totalVisitNum / 100000000).toFixed(2) + "亿"
              : dataAll.dataList.totalVisitNum
          }}，用户数{{
            userTypeHand.total > 10000
              ? (userTypeHand.total / 10000).toFixed(2) + "万"
              : userTypeHand.total
          }}；参与建设的院校有{{ dataAll.dataList.schoolNum }}所；参建企业有{{
            dataAll.dataList.companyNum
          }}家； {{ LeaveUp.Coveringspecialties.name }}数{{
            LeaveUp.Coveringspecialties.value
          }}个，其中{{ LeaveUp.vocationalschool.name }}专业数{{
            LeaveUp.vocationalschool.value
          }}个，{{ LeaveUp.Secondaryduty.name }}专业数{{
            LeaveUp.Secondaryduty.value > 10000
              ? (LeaveUp.Secondaryduty.value / 10000).toFixed(2) + "万"
              : LeaveUp.Secondaryduty.value
          }}个。
        </p>
      </div>

      <div class="chart_box">
        <h4>1.1 总体建设及应用分析</h4>
        <div class="chart_box">
          <h5>1.1.1 用户建设及应用</h5>
          <!-- 图 1 用户类型分布 （单位：人） -->
          <div class="chart_box">
            <!-- <p>截至2022年{{nowMonth}}月{{nowDay}}日，注册用户总计，其中学生总数最多{{unitMethod(userTypeHand.total,'万')[0]}}</p> -->
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
                userTypeHand.total > 10000
                  ? (userTypeHand.total / 10000).toFixed(2) + "万"
                  : userTypeHand.total
              }}，其中学生总数最多，共{{
                (this.userTypeHand.studentNum / 10000).toFixed(2)
              }}万，占比{{
                ((this.userTypeHand.studentNum / this.userTypeHand.total) * 100).toFixed(2)
              }}%， 其次是教师总数，共{{
                (this.userTypeHand.tearchNum / 10000).toFixed(2)
              }}万，占比{{
                ((this.userTypeHand.tearchNum / this.userTypeHand.total) * 100).toFixed(2)
              }}%。具体情况如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="userTypeHand.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 1 用户类型分布</div>
          </div>
          <!-- 图 2 用户类型分布 （单位：人） -->
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，近一年学生用户访问总量达{{
                userTalk.studentTotal > 100000000
                  ? (userTalk.studentTotal / 100000000).toFixed(2) + "亿"
                  : (userTalk.studentTota / 10000).toFixed(2) + "万"
              }}次，教师用户访问量达{{
                userTalk.teacherTotal > 10000
                  ? (userTalk.teacherTotal / 10000).toFixed(2) + "万"
                  : userTalk.teacherTotal
              }}次，具体访问趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="userTalk.dataList"
                :transverseData="userTalk.transverse"
                :colorList="userTalk.colorList"
                :innerText="'单位：次'"
                :legendList="userTalk.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 2 最近一年教师和学生访问情况</div>
          </div>
        </div>

        <div class="chart_box">
          <h5>1.1.2 课程建设及应用</h5>
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心共计{{
                courseTypeNum.total > 10000
                  ? (courseTypeNum.total / 10000).toFixed(2) + "万"
                  : courseTypeNum.total
              }}门课程，其中资源库的课程数量最多，占比{{
                ((this.courseTypeNum.maxArr.value / this.courseTypeNum.total) * 100).toFixed(2)
              }}%，具体课程来源分布如下图所示：
            </p>
            <!-- 图 3 课程来源分布 -->
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="courseTypeNum.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 3 课程来源分布</div>
          </div>

          <div style="height: 160px"></div>

          <!-- 图 4 近一年课程被访问总量 -->
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，近一年课程被访问总量达{{
                courseTalk.total > 10000000
                  ? (courseTalk.total / 100000000).toFixed(2) + "亿"
                  : (courseTalk.total / 10000).toFixed(2) + "万"
              }}次，平均月访问量达{{
                courseTalk.total / 12 > 10000
                  ? (courseTalk.total / 12 / 100000000).toFixed(2) + "亿"
                  : (courseTalk.total / 12 / 10000).toFixed(2) + "万"
              }}次，具体访问趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="courseTalk.dataList"
                :transverseData="courseTalk.transverseData"
                :colorList="courseTalk.colorList"
                :innerText="'单位：次'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 4 近一年课程被访问趋势图</div>
          </div>

          <div style="height: 100px"></div>

          <div class="chart_box">
            <p>
              据监测平台统计，截至2022年{{ nowMonth }}月{{ nowDay }}日，被访问量居首的课程是《{{
                courseTalkTable.MaxArr.courseName
              }}》，有{{
                courseTalkTable.MaxArr.courseTotalVisit > 100000000
                  ? (courseTalkTable.MaxArr.courseTotalVisit / 100000000).toFixed(2) + "亿"
                  : (courseTalkTable.MaxArr.courseTotalVisit / 10000).toFixed(2) + "万"
              }}次，具体课程被访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th style="width: 40%">课程名称</th>
                  <th>课程来源</th>
                  <!-- <th>平台</th> -->
                  <th>课程负责人</th>
                  <th>建设院校</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in courseTalkTable.dataList"
                  :key="index"
                  v-show="courseTalkTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.courseName }}</td>
                  <td>{{ item.courseType }}</td>
                  <!-- <td>{{item.platform}}</td> -->
                  <td>{{ item.majorTeacher }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.courseTotalVisit }}</td>
                </tr>

                <tr v-show="courseTalkTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 1 课程被访问量排名（前十五名）</div>
          </div>
        </div>
        <div style="height: 65px"></div>
        <div class="chart_box">
          <h5>1.1.3 资源建设及应用</h5>
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心资源总数达{{
                typeResources.sucai.value < 100000000
                  ? (typeResources.sucai.value / 10000).toFixed(2) + "万"
                  : typeResources.sucai.value
              }}条，共计容量有{{ typeResources.rongliang.value }}TB。 从资源类型来看，{{
                this.educationLevel.video.name
              }}类数量最多，有{{ (this.educationLevel.video.value / 10000).toFixed(2) }}万条，占比{{
                ((this.educationLevel.video.value / this.educationLevel.total) * 100).toFixed(2)
              }}%，具体资源类型分布如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="educationLevel.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 5 资源类型分布</div>
          </div>
          <div style="height: 700px"></div>
          <!-- <div style="height: 100px;" v-show="this.$route.query.endDay == '2022-10-31'"></div> -->

          <!-- <div style="height: 100px;" v-show="this.$route"></div> -->
          <!-- 日均访问资源{{resourceTable.resourceAvg>10000?(resourceTable.resourceAvg/10000).toFixed(2)+'万':resourceTable.resourceAvg}}次； -->
          <div class="chart_box">
            <p>
              资源访问总量已达{{
                resourceTable.resourceTotal > 100000000
                  ? (resourceTable.resourceTotal / 100000000).toFixed(2) + "亿"
                  : (resourceTable.resourceTotal / 10000).toFixed(2) + "万"
              }}次，其中访问次数最多的资源是《{{
                resourceTable.Max.name
              }}》，资源被访问量排名（前十五名）如下表所示：
            </p>
            <div style="height: 55px"></div>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源名称</th>
                  <th>资源类型</th>
                  <th>资源来源</th>
                  <!-- <th>上传人</th> -->
                  <th>建设院校</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in resourceTable.dataList"
                  :key="index"
                  v-show="resourceTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.resourceType }}</td>
                  <td>{{ item.zykName }}</td>
                  <!-- <td>{{item.author}}</td> -->
                  <td>{{ item.school }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="resourceTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 2 资源被访问量排名（前十五名）</div>
          </div>
        </div>
      </div>
      <div style="height: 175px"></div>
      <div class="chart_box">
        <h4>1.2 各省市建设及应用情况分析</h4>
        <div class="chart_box">
          <h5>1.2.1 各省用户建设及应用</h5>
          <p>
            截至2022年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
              userTypeHand.total > 10000
                ? (userTypeHand.total / 10000).toFixed(2) + "万"
                : userTypeHand.total + "万"
            }}，来自31个省份，其中注册用户最多的是{{ getUser.MaxArr.name }}省， 达{{
              (getUser.MaxArr.value / 10000).toFixed(2) + "万"
            }}用户之多；在线学习总人数有{{
              this.provinceStudy.total > 10000
                ? (this.provinceStudy.total / 10000).toFixed(2) + "万"
                : this.provinceStudy.total
            }}，在线学习人数最多的则是{{ provinceStudy.MaxArr.name }}，共{{
              provinceStudy.MaxArr.value > 10000
                ? (provinceStudy.MaxArr.value / 10000).toFixed(2) + "万"
                : provinceStudy.MaxArr.value
            }}人； 互动交流次数累计{{
              provinceTalking.total > 100000000
                ? (provinceTalking.total / 100000000).toFixed(2) + "亿"
                : (provinceTalking.total / 10000).toFixed(2) + "万"
            }}次，互动交流频次最多的是{{ provinceTalking.MaxArr.name }}，其次是{{
              provinceTalking.SecArr.name
            }}。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="getUser.dataList"
              :transverseData="getUser.legendList"
              :colorList="getUser.colorList"
              style="height: 140%"
            ></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 140px">
            图 6 各省注册用户数排名（前十五名）
          </div>
          <div style="height: 540px"></div>

          <!-- <div style="height: 50px;" v-show="this.$route.query.endDay == '2022-10-31'"></div> -->

          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="provinceStudy.dataList"
              :transverseData="provinceStudy.legendList"
              :colorList="provinceStudy.colorList"
              style="height: 140%; width: 110%"
            ></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 190px">
            图 7 各省在线学习人数排名（前十五名）
          </div>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="provinceTalking.dataList"
              :transverseData="provinceTalking.legendList"
              :colorList="provinceTalking.colorList"
              style="height: 140%; width: 110%"
            ></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 190px">
            图 8 各省交流互动量排名（前十五名）
          </div>
        </div>

        <div class="chart_box">
          <h5>1.2.2 各省课程建设及应用</h5>
          <!-- <p>参建课程的老师累计{{((this.userTypeList.tearchNum / 10000).toFixed(3))+'万'}}名，来自{{teacherProvince.MaxArr.name}}省的教师最多，有{{teacherProvince.MaxArr.value}}名。</p> -->
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，有31个省份参与建设课程，总计{{
                courseTypeNum.total > 10000
                  ? (courseTypeNum.total / 10000).toFixed(2) + "万"
                  : courseTypeNum.total
              }}门，其中建设课程数量最多的是{{ curriculum.MaxArr.name }}省， 总计建设{{
                (curriculum.MaxArr.value / 10000).toFixed(2) + "万"
              }}门课程。
            </p>

            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="curriculum.dataList"
                :transverseData="curriculum.legendList"
                :colorList="curriculum.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px">
              图 9 各省建设课程数量排名（前十五名）
            </div>

            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="teacherProvince.dataList"
                :transverseData="teacherProvince.legendList"
                :colorList="teacherProvince.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px">
              图 10 各省参与建设教师数排名（前十五名）
            </div>
          </div>
        </div>
        <div style="height: 100px"></div>
        <div class="chart_box">
          <h5>1.2.3 各省资源建设及应用</h5>
          <div class="chart_box">
            <p>
              截至2022年{{ nowMonth }}月{{ nowDay }}日，建设资源总数{{
                typeResources.sucai.value > 100000000
                  ? (typeResources.sucai.value / 100000000).toFixed(2) + "亿"
                  : (typeResources.sucai.value / 10000).toFixed(2) + "万"
              }}条，共有31个省份参与建设， 其中建设资源数量最多的是{{
                sourceMater.MaxArr.province
              }}省，有{{
                sourceMater.MaxArr.num > 10000
                  ? (sourceMater.MaxArr.num / 10000).toFixed(2) + "万"
                  : sourceMater.MaxArr.num
              }}条。 各省访问资源的总量达{{
                resourceTable.resourceTotal > 100000000
                  ? (resourceTable.resourceTotal / 100000000).toFixed(2) + "亿"
                  : (resourceTable.resourceTotal / 10000).toFixed(2) + "万"
              }}次，访问资源总量最多的是{{ visitProvince.MaxArr.name }}。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="sourceMater.dataList"
                :transverseData="sourceMater.legendList"
                :colorList="sourceMater.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px">
              图 11 各省建设资源数排名（前十五名）
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="visitProvince.dataList"
                :transverseData="visitProvince.legendList"
                :colorList="visitProvince.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px">
              图 12 各省访问资源数排名（前十五名）
            </div>
          </div>
        </div>
      </div>
      <div style="height: 20px" v-show="this.$route.query.endDay == '2022-12-31'"></div>

      <div class="chart_box">
        <h4>1.3 {{ startDay }}至{{ endDay }}整体运行情况分析</h4>
        <!-- 1.3.1.用户运行情况 -->
        <div class="chart_box">
          <h5>1.3.1 用户运行情况</h5>
          <div class="chart_box">
            <p>
              在分析时间内，新增注册用户累计{{
                userAdd.total > 10000 ? (userAdd.total / 10000).toFixed(2) + "万" : userAdd.total
              }}名，注册用户趋势图如下所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="userAdd.dataList1"
                :transverseData="userAdd.transverse"
                :colorList="userAdd.colorList"
                :legendList="userAdd.legendList"
                :innerText="'单位：名'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="userAdd.dataList2"
                :transverseData="userAdd.transverse"
                :colorList="userAdd.colorList"
                :legendList="userAdd.tran"
                :innerText="'单位：名'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 13 注册用户趋势图</div>
          </div>

          <div class="chart_box" style="margin-top: 300px">
            <p>
              在分析时间内，总用户访问量累计达{{
                userTimeTalk.total > 100000000
                  ? (userTimeTalk.total / 100000000).toFixed(2) + "亿"
                  : (userTimeTalk.total / 10000).toFixed(2) + "万"
              }}次，用户访问量趋势图如下所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="userTimeTalk.dataList"
                :transverseData="userTimeTalk.transverse"
                :colorList="userTimeTalk.colorList"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 14 用户被访问趋势图</div>
          </div>
        </div>
        <div style="height: 45px"></div>
        <!-- 1.3.2. 课程运行情况 -->
        <div class="chart_box">
          <h5>1.3.2 课程运行情况</h5>
          <div class="chart_box">
            <p>
              在分析时间内，新增课程数为{{
                courseNew.total > 10000
                  ? (courseNew.total / 10000).toFixed(2) + "万"
                  : courseNew.total
              }}门，课程被访问次数达{{
                courseTrend.total > 100000000
                  ? (courseTrend.total / 100000000).toFixed(2) + "亿"
                  : (courseTrend.total / 10000).toFixed(2) + "万"
              }}次，课程运行趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="courseNew.dataList"
                :transverseData="courseNew.transverse"
                :colorList="courseNew.colorList"
                :colorName="1"
                :innerText="'单位：门'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 15 新增课程趋势</div>
            <div style="height: 75px"></div>

            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="courseTrend.dataList"
                :transverseData="courseTrend.transverse"
                :colorList="courseTrend.colorList"
                :colorName="1"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 16 课程被访问趋势图</div>
          </div>
        </div>
        <div style="height: 205px"></div>

        <!-- 1.3.3. 资源运行情况 -->
        <div class="chart_box">
          <h5>1.3.3 资源运行情况</h5>
          <p>
            在分析时间内，新增资源数累计{{
              resourceNew.total > 10000
                ? (resourceNew.total / 10000).toFixed(2) + "万"
                : resourceNew.total
            }}条，资源被访问次数累计达{{
              resourceVisits.total > 10000
                ? (resourceVisits.total / 10000).toFixed(2) + "万"
                : resourceVisits.total
            }}次，资源运行趋势如下图所示：
          </p>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'resourcesMonthChart'"
              :datas="resourceNew.dataList"
              :transverseData="resourceNew.transverse"
              :colorList="colorList"
              :innerText="'单位：条'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">图 17 新增资源趋势</div>
          <div style="height: 220px"></div>

          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'resourcesMonthChart'"
              :datas="resourceVisits.dataList"
              :transverseData="resourceVisits.transverse"
              :colorList="resourceVisits.colorList"
              :innerText="'单位：次'"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">图 18 资源被访问趋势图</div>
        </div>
      </div>
      <div style="height: 140px"></div>

      <div class="chart_box">
        <h3>2. 专业教学资源库应用分析</h3>
        <div style="height: 25px"></div>
        <h4>2.1 资源库建设及应用情况</h4>
        <div style="height: 25px"></div>

        <p>
          截至2022年{{ nowMonth }}月{{ nowDay }}日，职业教育专业教学资源库已纳入监测项目共计{{
            resourceLevel.total
          }}个，其中{{ resourceLevel.countryNum.name }}资源库{{
            resourceLevel.countryNum.value
          }}个，{{ resourceLevel.provinceNum.name }}资源库{{
            resourceLevel.provinceNum.value
          }}个，{{ resourceLevel.schoolNum.name }}资源库{{
            resourceLevel.schoolNum.value
          }}个，覆盖了{{ getmajor.dataList.length - 1 }}个专业大类。 目前，已有{{
            dataAll.dataList.zykSchoolCount
          }}余所职业院校和{{ dataAll.dataList.companyNum }}余家行业企业参与建设；标准课程总量已达{{
            userConstruction.standardcourse.value
          }}门，资源库项目资源总量达{{
            this.typeResources.sucai.value > 10000
              ? (this.typeResources.sucai.value / 10000).toFixed(2) + "万"
              : this.typeResources.sucai.value
          }}余条，资源库共有注册用户{{
            userTypeList.total > 10000
              ? (userTypeList.total / 10000).toFixed(2) + "万"
              : userTypeList.total
          }}余人，总访问量{{
            dataAll.dataList.zykVisitNum > 100000000
              ? (dataAll.dataList.zykVisitNum / 100000000).toFixed(2) + "亿"
              : (dataAll.dataList.zykVisitNum / 10000).toFixed(2) + "万"
          }}次
          ，初步形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设应用情况如下：
        </p>
        <div style="height: 40px"></div>
        <div class="chart_box">
          <h5>2.1.1 用户建设及应用情况</h5>
          <div style="height: 25px"></div>

          <p>
            当前，资源库共有注册用户{{
              userTypeList.total > 10000
                ? (userTypeList.total / 10000).toFixed(2) + "万"
                : userTypeList.total
            }}余人，按用户身份类型统计，{{ userConstruction.tearchNum.name
            }}{{
              userConstruction.tearchNum.value > 10000
                ? (userConstruction.tearchNum.value / 10000).toFixed(2) + "万"
                : userConstruction.tearchNum.value
            }}余人，{{ userConstruction.studentNum.name
            }}{{
              userConstruction.studentNum.value > 10000
                ? (userConstruction.studentNum.value / 10000).toFixed(2) + "万"
                : userConstruction.studentNum.value
            }}余人。资源库{{ userConstruction.EnterpriseNum.name
            }}{{
              userConstruction.EnterpriseNum.value > 10000
                ? (userConstruction.EnterpriseNum.value / 10000).toFixed(2) + "万"
                : userConstruction.EnterpriseNum.value
            }}余人，能够较好地考虑了企业员工继续教育、技能提升的需求，
            合作企业实现了依托资源库开展员工继续教育培训；资源库共有{{
              userConstruction.socialNum.name
            }}{{
              userConstruction.socialNum.value > 10000
                ? (userConstruction.socialNum.value / 10000).toFixed(2) + "万"
                : userConstruction.socialNum.value
            }}余人，努力承担面向普通劳动者免费线上培训的社会责任。
          </p>
          <!-- <p>资源库项目整体用户访问资源总量约{{talkAll.resource>100000000?(talkAll.resource/100000000).toFixed(2) +'亿':(talkAll.resource / 10000).toFixed(2) + '万'}}次、用户访问课程总量约{{talkAll.course>100000000?(talkAll.course/100000000).toFixed(2) +'亿':(talkAll.course / 10000).toFixed(2) + '万'}}次，用户互动交流次数约{{talkAll.user>100000000?(talkAll.user/100000000).toFixed(2) +'亿':(talkAll.user / 10000).toFixed(2) + '万'}}次。分布详情如下所示：</p> -->

          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="userTypeList.dataList"
              :colorName="3"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">图 19 用户整体情况</div>
          <div style="height: 120px"></div>
          <div class="standards_content echartsHeight">
            <circularChart
              :refId="'typeDistributionChart'"
              :isShowTextColor="true"
              :datas="studentConstruction.dataList"
              :colorName="1"
              :innerText="'数量'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></circularChart>
          </div>
          <div class="chart_name">图 20 学生类型整体情况</div>
          <div style="height: 400px"></div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="userTalk.dataList"
              :transverseData="userTalk.transverse"
              :colorList="userTalk.colorList"
              :innerText="'单位：次'"
              :legendList="userTalk.legendList"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图 21 最近一年教师和学生访问情况</div>
          <div style="height: 140px"></div>
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="socialAndenterprise.dataList"
              :transverseData="socialAndenterprise.transverse"
              :colorList="socialAndenterprise.colorList"
              :innerText="'单位：次'"
              :legendList="socialAndenterprise.legendList"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
            ></discountChart>
          </div>
          <div class="chart_name">图 22 最近一年社会学习者和企业用户访问情况</div>
        </div>

        <div class="chart_box" style="margin-top: 180px">
          <h5>2.1.2 课程建设及应用情况</h5>
          <p>
            当前，资源库项目课程总量达到{{
              getcourse.total > 10000
                ? (getcourse.total / 10000).toFixed(2) + "万"
                : getcourse.total
            }}门，其中{{ getcourse.individualization.name
            }}{{
              getcourse.individualization.value > 10000
                ? (getcourse.individualization.value / 10000).toFixed(2) + "万"
                : getcourse.individualization.value
            }}门，{{ getcourse.Standardization.name
            }}{{
              getcourse.Standardization.value > 10000
                ? (getcourse.Standardization.value / 10000).toFixed(2) + "万"
                : getcourse.Standardization.value
            }}门 ，其中，注册学生用户访问最多的课程是《{{ courseDataAll.name }}》，属于“{{
              courseDataAll.zykName
            }}资源库”。在{{
              courseDataAll.zykDiv
            }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'resourcesMonthChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="getcourse.dataList"
              :transverseData="getcourse.transverseData"
              :colorList="getcourse.colorList"
            ></tcolumnarChart>
          </div>

          <div class="chart_name">图 23 课程整体情况</div>
          <div style="height: 90px"></div>

          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="courseTalk.dataList"
              :transverseData="courseTalk.transverseData"
              :colorList="courseTalk.colorList"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">图 24 最近一年课程访问情况</div>
        </div>

        <div style="height: 270px"></div>
        <!-- 日均访问资源{{ talkAll.resource / 365>10000?(talkAll.resource / 365 / 10000).toFixed(2) + '万':talkAll.course}}次 -->
        <div class="chart_box">
          <h5>2.1.3 资源建设及应用情况</h5>
          <p>
            资源库项目资源数量达{{
              (this.typeResources.sucai.value / 10000).toFixed(2)
            }}万条，视频类数量最多，有{{
              (this.educationLevel.video.value / 10000).toFixed(2) + "万"
            }}条 ，除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
              this.educationLevel.xuni.value
            }}条{{ this.educationLevel.xuni.name }}资源。资源访问总量已达{{
              talkAll.resource > 100000000
                ? (talkAll.resource / 100000000).toFixed(2) + "亿"
                : (talkAll.resource / 10000).toFixed(2) + "万"
            }}余次， 其中访问次数最多的资源是《{{ resourceTable.Max.name }}》，属于“{{
              resourceTable.Max.zykName
            }}”。
          </p>
          <div class="chart_box">
            <p>资源按类型分布详情如下：</p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="educationLevel.dataList"
                :transverseData="educationLevel.transverseData"
                :colorList="educationLevel.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图 25 资源整体情况</div>
          </div>
          <div style="height: 200px"></div>

          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="resource.dataList"
              :transverseData="courseTalk.transverseData"
              :colorList="courseTalk.colorList"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">图 26 最近一年资源访问情况</div>
        </div>
        <div style="height: 50px"></div>
        <div class="chart_box">
          <h5>2.1.4 国家级资源库应用情况分析</h5>
          <div class="chart_box">
            <p>1. 覆盖专业大类分析</p>
            <p v-if="getmajor.MaxArr.name != '其他'">
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，资源库覆盖{{
                getmajor.dataList.length - 1
              }}个专业大类。从专业大类分布看，所属“{{ getmajor.MaxArr.name }}”的资源库最多，占比达{{
                ((getmajor.MaxArr.value / this.getmajor.total) * 100).toFixed(2)
              }}%，具体分布如下图所示：
            </p>
            <p v-else>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，资源库覆盖{{
                getmajor.dataList.length - 1
              }}个专业大类。从专业大类分布看，所属“{{ getmajor.Second.name }}”的资源库最多，占比达{{
                ((getmajor.Second.value / this.getmajor.total) * 100).toFixed(2)
              }}%，具体分布如下图所示：
            </p>

            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="getmajor.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'10%'"
                :legendBackgroundColor="true"
                :legendLeft="'20%'"
                :circleSize="80"
                :seriesRight="'80%'"
                style="width: 120%"
              ></circularChart>
            </div>
            <div class="chart_name">图 27 资源库专业大类分布情况</div>
          </div>
          <div style="height: 35px"></div>
          <div class="chart_box" style="margin-top: 360px">
            <p>2. 按照访问量排名</p>
            <p>
              资源库项目中，“{{ getzykTable.FristArr.zykName }}资源库”的访问量最多，紧随其后的是“{{
                getzykTable.SecArr.zykName
              }}资源库”和“{{
                getzykTable.ThrArr.zykName
              }}资源库”。具体按照访问情况排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库名称</th>
                  <th>第一主持院校</th>
                  <th>课程数（门）</th>
                  <th>资源数（个）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in getzykTable.dataList"
                  :key="index"
                  v-show="getzykTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zykName }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.courseNum }}</td>
                  <td>{{ item.resourceCount }}</td>
                  <td>{{ item.logNum }}</td>
                </tr>

                <tr v-show="getzykTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 3 资源库被访问量排名（前十五名）</div>
          </div>
          <div style="height: 30px" v-if="endDay != '2022-12-31'"></div>
          <div style="height: 10px" v-else></div>

          <div class="chart_box">
            <p>3. 按照用户活跃情况分析</p>
            <p>
              资源库项目中，“{{ getzykACtive.Frist.name }}资源库”的活跃用户数最多，紧随其后的是“{{
                getzykACtive.Second.name
              }}资源库”和“{{ getzykACtive.Thrid.name }}资源库”。
            </p>
            <!-- <p>具体按照访问情况排名（前十五名）如下表所示：</p> -->
            <div style="height: 25px"></div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="getzykACtive.dataList"
                :transverseData="getzykACtive.transverseData"
                :colorList="getzykACtive.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px">
              图 28 资源库活跃用户排名情况（前十五名）
            </div>
          </div>
        </div>

        <!-- <div class="chart_box">
          <h5>2.1.5 资源库建设与应用情况排名</h5>
          <div class="chart_box">
            <p>1. 覆盖专业大类分析 </p>
            <p v-if="getmajor.MaxArr.name != '其他'">截止到2022年{{nowMonth}}月{{nowDay}}日，资源库覆盖{{getmajor.dataList.length - 1}}个专业大类。从专业大类分布看，所属“{{getmajor.MaxArr.name}}”的资源库最多，占比达{{((getmajor.MaxArr.value / this.getmajor.total) * 100).toFixed(2)}}%，具体分布如下图所示：</p>
            <p v-else>截止到2022年{{nowMonth}}月{{nowDay}}日，资源库覆盖{{getmajor.dataList.length - 1}}个专业大类。从专业大类分布看，所属“{{getmajor.Second.name}}”的资源库最多，占比达{{((getmajor.Second.value / this.getmajor.total) * 100).toFixed(2)}}%，具体分布如下图所示：</p>

            <div class="standards_content echartsHeight">
              <circularChart :refId="'typeDistributionChart'" :isShowTextColor="true" :datas='getmajor.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'10%'" :legendBackgroundColor="true" :legendLeft="'20%'" :circleSize="80" :seriesRight="'80%'" style="width:120%"></circularChart>
            </div>
            <div class="chart_name">图 27 资源库专业大类分布情况（只分析已关联专业大类的数据）</div>
          </div>
          <div style="height: 185px;"></div>
          <div class="chart_box" style="margin-top: 280px;">
            <p>2. 按照访问量排名</p>
            <p>资源库项目中，“{{getzykTable.FristArr.zykName}}资源库”的访问量最多，紧随其后的是“{{getzykTable.SecArr.zykName}}资源库”和“{{getzykTable.ThrArr.zykName}}资源库”。具体按照访问情况排名（前十五名）如下表所示：</p>
            <div class="biaoge">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                <tr>
                  <th>排名</th>
                  <th>资源库名称</th>
                  <th>第一主持院校</th>
                  <th>课程数（门）</th>
                  <th>资源数（个）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr v-for="(item,index) in getzykTable.dataList" :key="index" v-show="getzykTable.dataList.length > 0">
                  <td>{{index + 1}}</td>
                  <td>{{item.zykName}}</td>
                  <td>{{item.schoolName}}</td>
                  <td>{{item.courseNum}}</td>
                  <td>{{item.resourceCount}}</td>
                  <td>{{item.logNum}}</td>
                <tr v-show="getzykTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 3 资源库被访问量排名（前十五名）</div>
          </div>
          <div style="height: 170px;" v-if="endDay != '2022-12-31'"></div>
          <div style="height: 10px;" v-else></div>

          <div class="chart_box">
            <p>3. 按照用户活跃情况分析 </p>
            <p>
              资源库项目中，“{{getzykACtive.Frist.name}}资源库”的活跃用户数最多，紧随其后的是“{{getzykACtive.Second.name}}资源库”和“{{getzykACtive.Thrid.name}}资源库”。
            </p>
            <p>具体按照访问情况排名（前十五名）如下表所示：</p>
            <div style="height: 25px;"></div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'resourcesMonthChart'" :isExportTextColor="true" :isShowTextColor="true" :datas="getzykACtive.dataList" :transverseData="getzykACtive.transverseData" :colorList="getzykACtive.colorList" style="height:140%"></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 140px;">图 28 资源库活跃用户排名情况（前十五名）</div>
          </div>
        </div> -->
      </div>
      <!-- <div style="height: 40px;"></div> -->

      <div class="chart_box" style="margin-top: 40px">
        <h4>2.2 各省利用资源库开展教学总体情况</h4>
        <div class="chart_box">
          <h5>2.2.1 各省用户建设及应用</h5>
          <p>
            截至2022年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
              userTypeList.total > 10000
                ? (userTypeList.total / 10000).toFixed(2) + "万"
                : userTypeList.total + "万"
            }}，覆盖31个省份，其中注册用户最多的是{{ userProvince.MaxArr.province }}省，达{{
              userProvince.MaxArr.num > 10000
                ? (userProvince.MaxArr.num / 10000).toFixed(2) + "万"
                : userProvince.MaxArr.num
            }}个用户之多； 交流互动量次数累计{{
              talkAll.user > 100000000
                ? (talkAll.user / 100000000).toFixed(2) + "亿"
                : (talkAll.user / 10000).toFixed(2) + "万"
            }}次，互动交流频次最多的是{{ userProvince.from.province }}省，{{
              (userProvince.from.num / 10000).toFixed(2) + "万"
            }}次；在线学习总人数{{
              (userProvince.studyTotal / 10000).toFixed(2) + "万"
            }}，在线学习人数最多的则是{{ userProvince.MaxArr.province }}省。共{{
              userProvince.onilneMax.activeNum > 10000
                ? (userProvince.onilneMax.activeNum / 10000).toFixed(2) + "万"
                : userProvince.onilneMax.activeNum
            }}人。 资源库中各省份按照在线学习人数排名（前十五名）如下表所示：
          </p>
          <div class="chart_box">
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源库数（个）</th>
                  <th>注册用户数（人）</th>
                  <th>在线学习数（人）</th>
                  <th>交流互动量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in userProvince.dataList"
                  :key="index"
                  v-show="userProvince.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.zykCount }}</td>
                  <td>{{ item.num }}</td>
                  <td>{{ item.activeNum }}</td>
                  <td>{{ item.formun }}</td>
                </tr>

                <tr v-show="userProvince.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 4 资源库中各省份在线学习人数排名（前十五名）</div>
          </div>
          <div style="height: 180px"></div>
          <div class="standards_content echartsHeight" style="height: 1000px">
            <distributionChart
              :refId="'userTalk'"
              :datas="userProvince.mapdatas"
              :color="userProvince.mapcolorList"
              :isExportFont="18"
              :zoom="true"
            ></distributionChart>
          </div>
          <div class="chart_name">图 29 各省用户访问资源库分布</div>
        </div>
        <div class="chart_box" style="margin-top: 200px">
          <h5>2.2.2 各省课程建设及应用</h5>
          <p>
            截至2022年{{ nowMonth }}月{{ nowDay }}日，资源库建设课程总计{{
              getcourse.total > 10000
                ? (getcourse.total / 10000).toFixed(2) + "万"
                : getcourse.total
            }}门，覆盖31个省份，其中建设课程数量最多的是{{ curriculum.MaxArr.name }}省，有{{
              curriculum.MaxArr.value > 10000
                ? (curriculum.MaxArr.value / 10000).toFixed(2) + "万"
                : curriculum.MaxArr.value
            }}门；标准课程数累计有{{
              getcourse.Standardization.value > 10000
                ? (getcourse.Standardization.value / 10000).toFixed(2) + "万"
                : getcourse.Standardization.value
            }}门， 标准课程数最多的属于{{ curriculProvince.standard.name }}，共{{
              curriculProvince.standard.snum
            }}门，个性化课程数累计有{{ getcourse.individualization.name
            }}{{
              getcourse.individualization.value > 10000
                ? (getcourse.individualization.value / 10000).toFixed(2) + "万"
                : getcourse.individualization.value
            }}门，个性化课程数最多的是{{ curriculProvince.personality.name }}，{{
              curriculProvince.personality.pnum
            }}门。 具体各省资源库课程建设按照总课程数排名（前十五名）如下表所示：
          </p>
          <div class="chart_box">
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <!-- <th>参建教师数（名）</th> -->
                  <th>标准化课程数</th>
                  <th>个性化课程数</th>
                  <th>总课程数（门）</th>
                </tr>

                <tr
                  v-for="(item, index) in curriculProvince.dataList"
                  :key="index"
                  v-show="curriculProvince.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <!-- <td>{{item.teacher}}</td> -->
                  <td>{{ item.snum }}</td>
                  <td>{{ item.pnum }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="curriculProvince.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 5 各省资源库课程按照课程总量排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 650px">
          <h5>2.2.3 各省资源建设及应用</h5>
          <p>
            截至2022年{{ nowMonth }}月{{ nowDay }}日，资源库建设资源累计达{{
              typeResources.sucai.value > 100000000
                ? (typeResources.sucai.value / 100000000).toFixed(2) + "亿"
                : (typeResources.sucai.value / 10000).toFixed(2) + "万"
            }}个，覆盖31个省份， 其中建设资源数量最多的是{{ disksNum.buildMax.province }}省，有{{
              (disksNum.buildMax.num / 10000).toFixed(2) + "万"
            }}个。各省访问资源的总量达{{
              talkAll.resource > 100000000
                ? (talkAll.resource / 100000000).toFixed(2) + "亿"
                : (talkAll.resource / 10000).toFixed(2) + "万"
            }}次， 访问资源总量最多的是{{
              disksNum.MaxArr.province1
            }}省。具体各省资源库资源建设按照访问量情况排名（前十五名）如下表所示：
          </p>
          <div class="chart_box">
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源数（条）</th>
                  <th>资源量（TB）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in disksNum.dataList"
                  :key="index"
                  v-show="disksNum.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province1 }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.disksNum.toFixed(2) }}</td>
                  <td>{{ item.log }}</td>
                </tr>

                <tr v-show="disksNum.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 6 各省资源库资源访问量情况排名（前十五名）</div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h4>2.3 {{ startDay }}至{{ endDay }}资源库运行情况分析</h4>
        <div class="chart_box">
          <h5>2.3.1 资源库用户运行情况</h5>
          <div class="chart_box">
            <p>1. 用户新增情况分析</p>
            <div class="chart_box">
              <p>
                在该时间段内，学生用户新增共{{
                  (userAdd.Stotal / 10000).toFixed(2) + "万"
                }}名，教师用户新增共{{
                  userAdd.Ttotal > 10000
                    ? (userAdd.Ttotal / 10000).toFixed(2) + "万"
                    : userAdd.Ttotal
                }}名。师生新增情况如下所示：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'userTalk'"
                  :datas="userAdd.sAtdatas"
                  :transverseData="userAdd.transverse"
                  :colorList="userAdd.colorList"
                  :innerText="'单位：名'"
                  :legendList="userAdd.sAtlegendList"
                  :titleLeft="'32%'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="80"
                ></discountChart>
              </div>
              <div class="chart_name">图 32 {{ startDay }}至{{ endDay }}资源库师生用户新增趋势</div>
            </div>
          </div>
          <div style="height: 100px"></div>

          <div class="chart_box">
            <div class="chart_box">
              <p>2. 用户月活情况分析</p>
              <p>
                在该时间段内，资源库项目中累计活跃用户{{
                  (zykuserYun.userActiveTotal / 10000).toFixed(2) + "万"
                }}人，累计点击{{
                  zykuserYun.userActivelogNum > 100000000
                    ? (zykuserYun.userActivelogNum / 100000000).toFixed(2) + "亿"
                    : (zykuserYun.userActivelogNum / 10000).toFixed(2) + "万"
                }}次。其中，{{ zykuserYun.roleStudent.role }}活跃用户{{
                  (zykuserYun.roleStudent.num / 10000).toFixed(2) + "万"
                }}人，累计访问共{{
                  zykuserYun.roleStudent.logNum > 100000000
                    ? (zykuserYun.roleStudent.logNum / 100000000).toFixed(2) + "亿"
                    : (zykuserYun.roleStudent.logNum / 10000).toFixed(2) + "万"
                }}次；{{ zykuserYun.roleTeacher.role }}活跃用户{{
                  (zykuserYun.roleTeacher.num / 10000).toFixed(2) + "万"
                }}人 ，累计访问共{{
                  (zykuserYun.roleTeacher.logNum / 10000).toFixed(2) + "万"
                }}次；企业员工{{
                  zykuserYun.roleEnterprise.num > 10000
                    ? (zykuserYun.roleEnterprise.num / 10000).toFixed(2) + "万"
                    : zykuserYun.roleEnterprise.num
                }}人，累计访问{{ (zykuserYun.roleEnterprise.logNum / 10000).toFixed(2) + "万" }}次；
                社会学习者{{
                  zykuserYun.roleSocial.num > 10000
                    ? (zykuserYun.roleSocial.num / 10000).toFixed(2) + "万"
                    : zykuserYun.roleSocial.num
                }}人， 累计访问资源库{{
                  (zykuserYun.roleSocial.logNum / 10000).toFixed(2) + "万"
                }}次。各类型用户访问趋势图如下：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'userTalk'"
                  :datas="zykuserYun.userActiveRoleData"
                  :transverseData="zykuserYun.userActiveRoleTranserve"
                  :colorList="zykuserYun.colorList"
                  :innerText="'单位：次'"
                  :legendList="zykuserYun.userActiveRolelegendList"
                  :titleLeft="'32%'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="80"
                ></discountChart>
              </div>
              <div class="chart_name">
                图 31 {{ startDay }}至{{ endDay }}资源库各类型用户访问趋势
              </div>
            </div>
            <div style="height: 300px"></div>

            <p v-show="this.$route.query.type == 1">
              在该时间段内，资源库月活共{{
                (zykuserYun.userActiveTotals / 10000).toFixed(2) + "万"
              }}人，月活趋势如下图所示：
            </p>
            <p v-show="this.$route.query.type == 2">
              在该时间段内，资源库月活共{{
                (zykuserYun.userActiveTotals / 10000).toFixed(2) + "万"
              }}人，平均月活{{
                (zykuserYun.userActiveTotals / 3 / 10000).toFixed(2) + "万"
              }}人。月活趋势如下图所示：
            </p>
            <p v-show="this.$route.query.type == 3">
              在该时间段内，资源库月活共{{
                (zykuserYun.userActiveTotals / 10000).toFixed(2) + "万"
              }}人，平均月活{{
                (zykuserYun.userActiveTotals / 12 / 10000).toFixed(2) + "万"
              }}人。月活趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="zykuserYun.userActiveData"
                :transverseData="zykuserYun.userActiveTranserve"
                :colorList="zykuserYun.colorList"
                :colorName="1"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div style="height: 20px"></div>
            <div class="chart_name">图 30 {{ startDay }}至{{ endDay }}资源库月活趋势</div>
          </div>
          <div style="height: 50px"></div>

          <div class="chart_box">
            <p>3. 用户访问情况</p>
            <p>
              在该时间段内，被用户访问最多的资源库是{{ userTop.fristMax.projectTypeCn }}的“{{
                userTop.fristMax.zykName
              }}资源库”。具体被访问资源库排名（前十五名）和（后十五名）如下表所示：
            </p>
            <div class="chart_box">
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>资源库名称</th>
                    <th>第一主持院校</th>
                    <th>级别</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr
                    v-for="(item, index) in userTop.fristTop15"
                    :key="index"
                    v-show="userTop.fristTop15.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.zykName }}</td>
                    <td>{{ item.firstChargeUnit }}</td>
                    <td>{{ item.projectTypeCn }}</td>
                    <td>{{ item.num }}</td>
                  </tr>
                  <tr v-show="userTop.fristTop15.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">
                表 7 {{ startDay }}至{{ endDay }}资源库访问量排行榜（前十五名）
              </div>
            </div>
            <div style="height: 50px"></div>

            <div class="chart_box">
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>资源库名称</th>
                    <th>第一主持院校</th>
                    <th>级别</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr
                    v-for="(item, index) in userTop.last15"
                    :key="index"
                    v-show="userTop.last15.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.zykName }}</td>
                    <td>{{ item.firstChargeUnit }}</td>
                    <td>{{ item.projectTypeCn }}</td>
                    <td>{{ item.num }}</td>
                  </tr>
                  <tr v-show="userTop.last15.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">
                表 8 {{ startDay }}至{{ endDay }}资源库访问量排行榜（后十五名）
              </div>
            </div>
          </div>
        </div>
        <div style="height: 400px"></div>
        <!-- 2.3.2. 资源库课程运行情况 -->
        <div class="chart_box">
          <h5>2.3.2 资源库课程运行情况</h5>
          <div class="chart_box">
            <p>
              在分析时间内，资源库新增课程总数共{{
                courseNew.total > 10000
                  ? (courseNew.total / 10000).toFixed(2) + "万"
                  : courseNew.total
              }}门，具体新增情况如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="courseNew.dataList"
                :transverseData="courseNew.transverse"
                :colorList="courseNew.colorList"
                :colorName="1"
                :innerText="'单位：门'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 33 {{ startDay }}至{{ endDay }}资源库课程新增趋势</div>
          </div>
          <div style="height: 130px"></div>

          <div class="chart_box">
            <p>
              在该时间段内，据监测平台统计，被访问量居首的课程是《{{
                zykCourseRanks.MaxArr.name
              }}》，有{{
                (zykCourseRanks.MaxArr.num / 10000).toFixed(2) + "万"
              }}次，具体课程按照访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程名称</th>
                  <th style="width: 400px">所属资源库</th>
                  <th>级别</th>
                  <th>课程负责人</th>
                  <th>访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in zykCourseRanks.dataList"
                  :key="index"
                  v-show="zykCourseRanks.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.project_type_cn }}</td>
                  <td>{{ item.author }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="zykCourseRanks.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 9 课程被访问量排名（前十五名）</div>
          </div>
        </div>
        <div style="height: 60px"></div>
        <!-- 2.3.3. 资源库资源运行情况 -->
        <div class="chart_box">
          <h5>2.3.3 资源库资源运行情况</h5>
          <div class="chart_box">
            <p>
              在分析时间内，资源库新增资源数为{{
                (zyktalk.total / 10000).toFixed(2) + "万"
              }}条，具体资源库新增资源数排名（前十五名）情况如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库</th>
                  <th>第一主持院校</th>
                  <th>级别</th>
                  <th>新增资源数</th>
                </tr>

                <tr
                  v-for="(item, index) in zyktalk.newRank"
                  :key="index"
                  v-show="zyktalk.newRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.project_type_cn }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="zyktalk.newRank.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 10 资源库按照新增的资源数排名（前十五名）</div>
          </div>
          <div style="height: 250px"></div>
          <div class="chart_box">
            <p>
              在分析时间内，资源库资源被访问总量达{{
                courseTrend.total > 100000000
                  ? (courseTrend.total / 100000000).toFixed(2) + "亿"
                  : (courseTrend.total / 10000).toFixed(2) + "万"
              }}次，其中，“{{
                zyktalk.MaxArr.zyk_name
              }}资源库”的资源数被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库</th>
                  <th>第一主持院校</th>
                  <th>级别</th>
                  <th>资源访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in zyktalk.logRank"
                  :key="index"
                  v-show="zyktalk.logRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.project_type_cn }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="zyktalk.logRank.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 11 资源库按照资源被访问量排名（前十五名）</div>
          </div>
        </div>
      </div>

      <div style="height: 200px"></div>

      <div class="chart_box">
        <h3>3. 在线精品课应用分析</h3>
        <!-- <div style="height: 50px;" v-if="this.$route.query.endDay == '2022-10-31'"></div> -->
        <div style="height: 20px"></div>
        <p>
          依据监测平台统计，截止到2022年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共建{{
            dataAll.dataList.onlineCourseNum
          }}门，其中，{{ ByLevel.SecArr.name }}课程有{{ ByLevel.SecArr.value }}门，{{
            ByLevel.FristArr.name
          }}课程有{{ ByLevel.FristArr.value }}门，{{ ByLevel.ThrArr.name }}课程有{{
            ByLevel.ThrArr.value
          }}门， 目前，在线精品课程已有{{ catorStat.datas1.value }}所院校和{{
            catorStat.datas2.value > 10000
              ? (catorStat.datas2.value / 10000).toFixed(2) + "万"
              : catorStat.datas2.value
          }}名教师参与建设与应用；总访问量达{{
            (catorStat.datas3.value / 100000000).toFixed(2) + "亿"
          }}次，总开课期数为{{
            catorStat.datas4.value > 10000
              ? (catorStat.datas4.value / 10000).toFixed(2) + "万"
              : catorStat.datas4.value
          }}期，总课时数为{{ (catorStat.datas5.value / 10000).toFixed(2) + "万" }}课时，
          总选课人数{{ (catorStat.datas6.value / 10000).toFixed(2) + "万" }}人，总互动次数{{
            catorStat.datas7.value > 100000000
              ? (catorStat.datas7.value / 100000000).toFixed(2) + "亿"
              : (catorStat.datas7.value / 10000).toFixed(2)
          }}次；具体建设与应用情况如下：
        </p>
        <div class="chart_box">
          <h5>3.1 在线精品课建设情况</h5>
          <div style="height: 20px"></div>

          <p>1. 各省建设课程数量排名</p>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，在线精品课建设共纳入监测{{
                dataAll.dataList.onlineCourseNum
              }}门，其中，{{ couseRank.MaxArr.province }}省建设课程数量最多，共{{
                couseRank.MaxArr.total
              }}门，具体各省建设课程数量排名（前十五名）如下表所示：
            </p>
            <!-- <div style="height: 50px;" v-if="this.$route.query.endDay == '2022-10-31'"></div> -->
            <!-- <div style="height: 130px;"></div> -->
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>建设课程数</th>
                  <th>选课人数</th>
                </tr>

                <tr
                  v-for="(item, index) in couseRank.dataList"
                  :key="index"
                  v-show="couseRank.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.total }}</td>
                  <td>{{ item.studynum }}</td>
                </tr>
                <tr v-show="couseRank.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 12 各省建设在线精品课数量排名（前十五名）</div>
          </div>
        </div>
        <div style="height: 200px"></div>
        <div class="chart_box" style="margin-top: 310px">
          <h5>3.2 在线精品课访问情况</h5>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计访问量{{
                catorStat.datas3.value > 100000000
                  ? (catorStat.datas3.value / 100000000).toFixed(2) + "亿"
                  : (catorStat.datas3.value / 10000).toFixed(2) + "万"
              }}，访问量最高的课程是{{ couseAll.MaxArr.schoolname }}的《{{
                couseAll.MaxArr.name
              }}》，访问量排名（前十五名）的课程信息如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in couseAll.dataList"
                  :key="index"
                  v-show="couseAll.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="couseAll.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 13 在线精品课访问量排名（前十五名）</div>
          </div>
        </div>
        <!-- <div style="height:70px"></div> -->

        <div class="chart_box">
          <h5>3.3 在线精品课开课情况</h5>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计开课期数{{
                catorStat.datas4.value > 10000
                  ? (catorStat.datas4.value / 10000).toFixed(2) + "万"
                  : catorStat.datas4.value
              }}期，开课期数最多的课程是{{ couseOpen.MaxArr.schoolname }}的《{{
                couseOpen.MaxArr.name
              }}》，开课期数排名（前十五名）的课程信息如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>开课期数</th>
                </tr>

                <tr
                  v-for="(item, index) in couseOpen.dataList"
                  :key="index"
                  v-show="couseOpen.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="couseOpen.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 14 在线精品课开课期数排名（前十五名）</div>
          </div>
        </div>
        <!-- <div style="height:80px"></div> -->

        <div class="chart_box">
          <h5>3.4 在线精品课选课情况</h5>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计选课人数{{
                (catorStat.datas6.value / 10000).toFixed(2) + "万"
              }}人，选课人数最多的课程是{{ courseSelect.MaxArr.schoolname }}学院的《{{
                courseSelect.MaxArr.name
              }}》，选课人数排名（前十五名）的课程信息如下：
            </p>

            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>选课人数</th>
                </tr>

                <tr
                  v-for="(item, index) in courseSelect.dataList"
                  :key="index"
                  v-show="courseSelect.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="courseSelect.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 15 在线精品课程选课人数排名（前十五名）</div>
          </div>
        </div>
      </div>
      <!-- ，总互动次数N次。具体建设与应用情况如下： -->
      <div class="division">
        <span></span>
      </div>

      <div class="chart_box">
        <h3>4. 视频公开课应用分析</h3>
        <div style="height: 50px"></div>
        <!-- <h4>4.1 视频公开课建设及应用情况</h4> -->

        <p>
          依据监测平台统计，截止到2022年{{ nowMonth }}月{{ nowDay }}日，视频公开课共纳入监测{{
            courseVideo.datas5.value
          }}门，其中， {{ courseVideo.datas1.name }}有{{ courseVideo.datas1.value }}门、{{
            courseVideo.datas2.name
          }}有{{ courseVideo.datas2.value }}门、{{ courseVideo.datas3.name }}有{{
            courseVideo.datas3.value
          }}门、{{ courseVideo.datas4.name }}比赛获奖作品有{{ courseVideo.datas4.value }}门。
          目前，视频公开课已有{{ courseVideo3.datas8.value }}所院校和{{
            courseVideo3.datas6.value
          }}名教师参与建设与应用；总访问量达{{
            (courseVideo3.datas7.value / 10000).toFixed(2) + "万"
          }}次，总开课期数为{{ courseVideo3.datas3.value }}期，总课时数为{{
            courseVideo3.datas1.value > 10000
              ? (courseVideo3.datas1.value / 10000).toFixed(2) + "万"
              : courseVideo3.datas1.value
          }}课时，总选课人数{{
            (courseVideo3.datas5.value / 10000).toFixed(2) + "万"
          }}人。具体建设与应用情况如下：
        </p>

        <div style="height: 50px"></div>

        <div class="chart_box">
          <h5>4.1 视频公开课建设情况</h5>
          <div style="height: 50px"></div>

          <!-- <p>1. 各省参建课程数量排名</p> -->
          <p>1. 各省视频公开课建设情况</p>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，视频公开课课程总计{{
                courseVideo.datas5.value
              }}门，其中，{{ courseTop.MaxArr.province }}省建设课程数量最多，共{{
                courseTop.MaxArr.total
              }}门，具体各省建设课程数量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>建设课程数</th>
                  <th>选课人数</th>
                </tr>

                <tr
                  v-for="(item, index) in courseTop.dataList"
                  :key="index"
                  v-show="courseTop.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.total }}</td>
                  <td>{{ item.studynum }}</td>
                </tr>
                <tr v-show="courseTop.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 16 各省建设视频公开课数量排名（前十五名）</div>
          </div>
        </div>

        <!-- <div style="height: 350px;"></div> -->

        <div class="chart_box">
          <h5>4.2 视频公开课访问情况</h5>
          <div style="height: 8px"></div>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计访问量{{
                (courseVideo3.datas7.value / 10000).toFixed(2) + "万"
              }}，访问量最高的课程是{{ courseVideoPen.MaxArr.schoolname }}的《{{
                courseVideoPen.MaxArr.name
              }}》，访问量排名（前十五名）的课程信息如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>课程类型</th>
                  <th>访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in courseVideoPen.dataList"
                  :key="index"
                  v-show="courseVideoPen.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.platform }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="courseVideoPen.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 17 视频公开课访问量排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 600px">
          <h5>4.3 视频公开课选课情况</h5>
          <div class="chart_box">
            <p>
              截止到2022年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计选课人数{{
                (courseVideo3.datas5.value / 10000).toFixed(2) + "万"
              }}人，选课人数最多的课程是{{ courseVideoSel.MaxArr.schoolname }}的《{{
                courseVideoSel.MaxArr.name
              }}》，选课人数（前十五名）的课程信息如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>平台</th>
                  <th>选课人数</th>
                </tr>

                <tr
                  v-for="(item, index) in courseVideoSel.dataList"
                  :key="index"
                  v-show="courseVideoSel.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.courseclass }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="courseVideoSel.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 18 视频公开课选课人数排名（前十五名）</div>
            <div style="height: 1745px" v-if="this.$route.query.endDay == '2022-12-31'"></div>
            <div style="height: 1830px" v-else></div>
            <div
              style="height: 70px"
              v-if="this.nowMonth == '12' && this.$route.query.type == 1"
            ></div>
            <div
              style="height: 38px"
              v-if="this.nowMonth == '11' && this.$route.query.type == 1"
            ></div>
            <div
              style="height: 30px"
              v-if="this.nowMonth == '10' && this.$route.query.type == 1"
            ></div>
            <div
              style="height: 26px"
              v-if="this.Quarter == '第3季度' && this.$route.query.type == 2"
            ></div>
            <div
              style="height: 70px"
              v-if="this.Quarter == '第4季度' && this.$route.query.type == 2"
            ></div>
            <div style="height: 67px" v-if="this.$route.query.type == 3"></div>
          </div>
        </div>
      </div>
      <el-backtop></el-backtop>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import mapChart from "@/components/chart/mapChart.vue"; // 地图
import hotMapChart from "@/components/chart/hotMapChart.vue"; // 地图

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
    mapChart,
    hotMapChart,
  },
  data() {
    return {
      year: "",
      yearAndMonthly: "",
      yearMonthText: "",
      zykStatus: "已立项",
      dataAll: {
        dataList: [],
      },
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      color: [
        "#ffd9d9",
        "#ff0000",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ],
      header: {
        allHostUnit: "",
        coHostUnit: [],
        endTime: "",
        hostUnit: "",
        startTime: "",
        status: "",
        zykName: "",
        zykNum: "",
      },
      // 各校等级,覆盖专业
      LeaveUp: {
        dataList: [],
        Coveringspecialties: {},
        vocationalschool: {},
        Secondaryduty: {},
      },
      // 图 1 用户分布
      userTypeHand: {
        dataList: [],
        total: null,
        studentNum: 0,
        teacherNum: 0,
        total: 0,
      },
      // 用户类型分布
      userTypeList: {
        dataList: [],
        legendList: [],
        studentNum: 0,
        teacherNum: 0,
        total: 0,
      },
      // 用户访问量
      userTalk: {
        dataList: [],
        legendList: ["教师", "学生"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        teacherTotal: null,
        studentTotal: null,
      },
      // 数据总览
      courseTypeNum: {
        dataList: [],
        joinSchool: {},
        joinComp: {},
        total: 0,
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        schoolNum: [],
        companyNum: [],
        maxArr: [],
      },

      // 课程被访问总量
      courseTalk: {
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        total: 0,
      },

      // 课程被访问量排名
      courseTalkTable: {
        dataList: [],
        MaxArr: [],
        total: null,
      },

      //
      zykCourseRanks: {
        dataList: [],
        MaxArr: {},
      },

      // 资源访问情况
      resource: {
        dataList: [],
        transverse: [],
      },
      // 各类型资源数量
      typeResources: {
        dataList: [],
        legendList: [],
        sucai: {},
        rongliang: {},
      },

      // 各类资源占比
      educationLevel: {
        dataList: [],
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        video: {},
        xuni: {},
        Max: {},
        total: null,
      },

      // 获取资源访问量排名前15
      resourceTable: {
        dataList: [],
        MaxArr: [],
        Max: {},
        MaxZykname: {},
        resourceAvg: null,
        resourceTotal: null,
      },

      // 获取省份用户数排名 前（15名）
      getUser: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], //柱状图，折线图颜色
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 各省在线学习人数排名（前十五）
      provinceStudy: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], //柱状图，折线图颜色
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 各省交流互动量排名（前十五名）
      provinceTalking: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        SecArr: [],
        total: null,
      },
      // 课程数量分布
      curriculum: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 获取省份教师数排名前15
      teacherProvince: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },

      // 素材资源量排名
      sourceMater: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },

      // 各省访问资源数排名
      visitProvince: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 获取区间内每月新增用户数
      userAdd: {
        dataList1: [],
        dataList2: [],

        sAtdatas: [],
        Stotal: null,
        Ttotal: null,
        sAtlegendList: ["学生", "教师"],
        legendList: ["学生", "教师", "社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 获取区间内每月新增用户数
      userTimeTalk: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 新增课程数
      courseNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 新增课程趋势
      courseTrend: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },

      // 新增资源数
      resourceNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },

      // 新增资源趋势
      resourceVisits: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      resourceLevel: {
        dataList: [],
        total: null,
        countryNum: {},
        provinceNum: {},
        schoolNum: {},
      },

      // 用户建设
      userConstruction: {
        dataList: [],
        userData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
        userTotal: null,
        tearchNum: {},
        studentNum: {},
        socialNum: {},
        EnterpriseNum: {},
        standardcourse: {},
      },
      // 访问总体
      talkAll: {
        resource: null,
        course: null,
        user: null,
      },
      // 学生类型整体情况
      studentConstruction: {
        dataList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
      },

      // 近一年社会学习者和企业用户访问情况
      socialAndenterprise: {
        dataList: [],
        legendList: ["社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
      },

      // 获取课程建设
      getcourse: {
        dataList: [],
        individualization: {},
        Standardization: {},
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        total: null,
      },
      courseDataAll: {
        name: null,
        zykDiv: null,
        zykName: null,
      },
      // 获取专业大类
      getmajor: {
        dataList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        MaxArr: {},
        Second: {},
        total: null,
      },
      // 资源库访问情况排名（前十五名）
      getzykTable: {
        dataList: [],
        datas: [],
        transverseData: [],
        FristArr: [],
        SecArr: [],
        ThrArr: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
      },
      // 资源库用户活跃情况
      getzykACtive: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        Thrid: {},
      },
      // 2.2.1.各省用户建设及应用
      userProvince: {
        dataList: [],
        from: {},
        studentUser: {},
        mapdatas: [],
        mapcolorList: ["#ffd9d9"],
        MaxArr: [],
        onilneMax: {},
        total: null,
        talkTotal: null,
        studyTotal: null,
      },

      // 各省课程建设及应用
      curriculProvince: {
        dataList: [],
        MaxArr: [],
        SerArr: [],
        total: null,
        stotal: null, // 标准化课程总数
        ptotal: null, // 个性化课程总数
        standard: {},
        personality: {},
      },

      // 资源库省份资源建设情况
      disksNum: {
        total: null,
        totalLog: null,
        dataList: [],
        MaxArr: [],
        buildMaxArr: [],
        buildMax: {},
        maxProvince: {},
      },

      // 资源库用户运行情况
      zykuserYun: {
        // 资源库用户月活情况分析
        userActiveTotal: null,
        userActiveData: [],
        userActiveTranserve: [],
        userActiveTotals: null,

        userActivelogNum: null,
        userActiveRoleData: [],
        userActiveRoleTranserve: [],
        userActiveRolelegendList: [],

        roleStudent: {},
        roleTeacher: {},
        roleEnterprise: {},
        roleSocial: {},

        userActiveMonthTransverseData: [],
        userActiveMonthDataList: [],
      },

      // 访问情况排名(前十五、后十五)
      userTop: {
        fristTop15: [],
        fristMax: [],
        last15: [],
        lastMax: [],
      },
      zykAdd: {
        dataList: [],
      },
      //  资源库资源运行情况 （新增资源数） +（资源访问量）
      zyktalk: {
        total: null,
        totalLog: null,
        newRank: [],
        logRank: [],
        MaxArr: [],
      },
      // 在线精品课
      ByLevel: {
        dataList: [],
        total: null,
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {},
      },
      Platform: {
        dataList: [],
        Plat: {},
        total: null,
      },
      catorStat: {
        dataList: [],
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
        datas7: {},
      },
      couseRank: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程总访问量排名
      couseAll: {
        dataList: [],
        MaxArr: [],
        total: null,
      },

      // 课程开课期数
      couseOpen: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程选课人次排名
      courseSelect: {
        dataList: [],
        MaxArr: {},
        total: null,
      },

      courseVideo: {
        dataList: [],
        datas1: [],
        datas2: [],
        datas3: [],
        datas4: [],
        datas5: [],
      },
      courseVideo2: {
        dataList: [],
        ploaNum: {},
      },
      courseVideo3: {
        dataList: [],
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
        datas7: {},
        datas8: {},
      },
      courseTop: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 视频公开课访问情况
      courseVideoPen: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 视频选课
      courseVideoSel: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      projectTop: {
        // 图三 参加单位注册用户数排名
        dataList: [],
        colorList: [],
        transverseData: [],
      },

      resourcesMonth: {
        // 图4 资源库各类型素材资源新增情况
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: [],
        total: 0,
      },

      visitsMonth: {
        // 图7 课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      totalNum: 0,
      loading: "", // 是否导出加载中
      startDay: "",
      endDay: "",

      // 现在的时间
      nowMonth: "",
      nowDay: "",
      type: "",
      nowYear: "",
      Quarter: "",
      // titleMonth
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.$route.query.endDay.slice(0, 4);
      if (
        this.$route.query.startDay == "2022-01-01" &&
        this.$route.query.endDay == "2022-03-31" &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第1季度";
      } else if (
        this.$route.query.startDay == "2022-04-01" &&
        this.$route.query.endDay == "2022-06-30" &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第2季度";
      } else if (
        this.$route.query.startDay == "2022-07-01" &&
        this.$route.query.endDay == "2022-09-30" &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第3季度";
      } else if (
        this.$route.query.startDay == "2022-10-01" &&
        this.$route.query.endDay == "2022-12-31" &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第4季度";
      }
      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      sessionStorage.setItem("zykId", zykid);
    }
    this.nowDate(); //   获取当前时间日期

    this.dataAllHandler(); //  数据总览
    this.leaveHanderl(); //  各校等级,覆盖专业
    this.userTypeHandler(); //  图 1 用户分布

    this.userType(); //  用户类型分布
    this.userTalking(); //  用户具体访问趋势

    this.courseNum(); //  课程来源分布
    this.courseTalkHanderl(); //  课程被访问总量
    this.zykCourseRankHandler(); //  区间内资源库课程访问量排名
    this.courseTalkTableHandler(); //  课程被访问量排名

    // 1.1.3  资源存储量 + 资源类型
    this.resourcesNumber(); //  资源存储量
    this.resourcesProportion(); //  各类型资源占比
    this.resourceTableHandler(); //  获取资源访问量排名（前十五）
    // 1.2 各省市建设及应用情况分析
    this.getuser(); //  获取省份用户数排名前15
    this.provinceStudyNum(); //  各省在线学习人数排名（前十五）
    this.provinceTalk(); //  各省交流互动量排名（前十五名）

    // 1.3.1    用户运行情况
    this.curriculumNum(); //  课程数量分布
    this.teacherNumType(); //  获取省份教师数（前十五名）
    this.sourceMaterial(); //  素材资源量排名
    this.visitProvinceHandler(); //  各省建设资源数排名

    // 1.3.2    课程运行情况
    this.userAddHanderl(); //  获取区间内每月新增用户数
    this.userTimeTalkHanderl(); //  用户访问量趋势
    this.courseNewHandler(); //  区间课程新增
    // this.courseTrendHandler()           //  区间课程新增趋势

    // 1.3.3       资源运行情况
    // this.resourceNewHandler()           //  区间新增课程数
    // this.resourceVisitsHandler()        //  区间新增课程趋势

    // 2.1
    this.resourceLevelHandler(); //  专业教学资源库应用分析
    this.userConstructionHandler(); //   用户建设

    // 2.2.1  用户建设及应用情况
    this.talkAllHandler(); //   获取访问总体情况
    this.studentConstructionHandler(); //   学生类型整体情况
    this.socialAenterpriseHandler(); //   近一年社会学习者和企业用户访问情况
    this.getcourseHandler(); //   获取国家端-课程画像-课程数量图
    this.courseAllHandler(); //   课程整体情况
    // 2.1.4  国家级资源库应用情况分析
    this.getmajorHandler(); //   覆盖专业大类分析
    this.getzykHandler(); //   资源库访问情况排名（前十五名）
    this.getzykACtiveHandler(); //   资源库活跃情况
    // 2.2.1  各省用户建设及应用
    this.getuserProHandeler(); //   各省用户建设及应用
    this.curriculProvinceHandler(); //   资源库课程介绍
    this.disksNumHandler(); //   资源库省份资源建设情况
    this.zykuserYunHandler(); //   资源库用户运行情况

    this.fristAlast(); //   访问情况排名(前十五、后十五)
    this.zyktalkHandler(); //   资源库资源运行情况

    // 第三部分
    // 3.1 标题部分
    this.ByLevelHandler(); //    在线精品课
    this.PlatformHandler(); //    平台数量和平台课程数（前三）
    this.catorStatHandler();

    // 3.1.1  3.1.2  3.1.3  3.1.4
    this.courseProvinceRank(); //    在线精品课_参加课程数量各省排名
    this.courseAlltalk(); //    在线精品课访问情况
    this.couseOpenHandler(); //    在线精品课开课期数
    this.courseSelection(); //    课程选课人次排名

    // 第四部分
    // 4.1 标题部分
    this.ByLevelcourseVideo(); //    视频公开课建设及应用情况
    this.PlatformVideoHandler();
    this.catorStatVideoHandler();

    // 4.1.1   4.1.2   4.1.3
    this.courseTopHandler();
    this.courseVideoPenHandler();
    this.courseVideoSelHandler();
  },

  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let Frist = this.$route.query.endDay.indexOf("-") + 1;
      let last = this.$route.query.endDay.lastIndexOf("-") + 1;
      this.nowMonth = this.$route.query.endDay.slice(Frist, last - 1);
      this.nowDay = this.$route.query.endDay.slice(last, this.$route.query.endDay.length);
    },

    reload() {
      //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .post(
          this.$apiurls.exportMonthReport,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },

    dataAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportOverview, {
          loading: false,
        })
        .then((res) => {
          this.dataAll.dataList = res.data;
        });
    },

    // 各校等级,覆盖专业
    leaveHanderl() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getSchoolCollegeLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = [];
            for (let i = 0; i < res.data.dataList.length; i++) {
              datas.push({ name: res.data.transverseData[i], value: res.data.dataList[i] });
            }
            this.LeaveUp.dataList = datas;
            this.LeaveUp.Coveringspecialties = datas.find((item) => item.name == "覆盖专业");
            this.LeaveUp.vocationalschool = datas.find((item) => item.name == "高职");
            this.LeaveUp.Secondaryduty = datas.find((item) => item.name == "中职");
          }
        });
    },

    // 图 1 用户分布
    userTypeHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserOverview, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.userTypeHand.total += res.data.value[i];
            this.userTypeHand.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          // 教师数量
          let tearch = this.userTypeHand.dataList.find((item) => item.name == "教师");
          this.userTypeHand.tearchNum = tearch.value;
          // 学生数
          let student = this.userTypeHand.dataList.find((item) => item.name == "学生");
          this.userTypeHand.studentNum = student.value;
          this.userTypeHand.legendList = res.data.name;
          // this.userTypeHand.dataList = datas
        });
    },

    // 图 1 当前资源库资源、课程情况
    userType() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getUserTypeDistribute, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = [];
            for (let i = 0; i < res.data.name.length; i++) {
              this.userTypeList.total += res.data.value[i];
              datas.push({ name: res.data.name[i], value: res.data.value[i] });
            }

            // 教师数量
            let tearch = datas.find((item) => item.name == "教师");
            this.userTypeList.tearchNum = tearch.value;
            // 学生数
            let student = datas.find((item) => item.name == "学生");
            this.userTypeList.studentNum = student.value;
            this.userTypeList.legendList = res.data.name;
            this.userTypeList.dataList = datas;
          }
        });
    },
    // 图 2 用户具体访问趋势 （学生 + 教师）
    userTalking() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserMonthVisits, {
          loading: false,
        })
        .then((res) => {
          this.userTalk.dataList.push(res.data.student.value, res.data.teacher.value);
          this.userTalk.transverse = res.data.student.name;
          this.userTalk.dataList[0].forEach((item) => {
            this.userTalk.teacherTotal += item;
          });
          this.userTalk.dataList[1].forEach((item) => {
            this.userTalk.studentTotal += item;
          });
        });
    },

    // 图 3 課程數量
    courseNum() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportOverview, {
          loading: false,
        })
        .then((res) => {
          this.courseTypeNum.dataList.push(
            {
              name: "资源库课程数",
              value: res.data.courseNum,
            },
            {
              name: "在线精品课数",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课数",
              value: res.data.videoCourseNum,
            }
          );

          let datas = [];
          datas.push(
            {
              name: "参建院校",
              value: res.data.schoolNum,
            },
            {
              name: "参建企业",
              value: res.data.companyNum,
            }
          );

          this.courseTypeNum.joinSchool = datas.find((item) => item.name == "参建院校");
          this.courseTypeNum.joinComp = datas.find((item) => item.name == "参建院校");

          this.courseTypeNum.dataList.forEach((item) => {
            this.courseTypeNum.total += item.value;
          });
          // 最大值得数组
          function sortMax(a, b) {
            return b.value - a.value;
          }
          this.courseTypeNum.dataList.sort(sortMax);
          this.courseTypeNum.maxArr = this.courseTypeNum.dataList[0];
          this.courseTypeNum.schoolNum.push({ name: "参建院校", value: res.data.schoolNum });
          this.courseTypeNum.companyNum.push({ name: "参建企业", value: res.data.companyNum });
        });
    },
    // 获取课程近一年访问趋势
    courseTalkHanderl() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseMonthVisits, {
          loading: false,
        })
        .then((res) => {
          this.resource.dataList = res.data.resource.value;
          this.courseTalk.dataList = res.data.course.value;
          this.courseTalk.transverseData = res.data.course.name;
          this.courseTalk.dataList.forEach((item) => {
            this.courseTalk.total += item;
          });
        });
    },

    zykCourseRankHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseRank, {
          loading: false,
        })
        .then((res) => {
          this.zykCourseRanks.dataList = res.data;
          this.zykCourseRanks.MaxArr = this.zykCourseRanks.dataList[0];
        });
    },

    // 课程被访问量排名
    courseTalkTableHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseRank, {
          loading: false,
        })
        .then((res) => {
          this.courseTalkTable.dataList = res.data;
          this.courseTalkTable.dataList.forEach((item) => {
            this.courseTalkTable.total += item.courseTotalVisit;
          });

          function Sort(a, b) {
            return b.courseTotalVisit - a.courseTotalVisit;
          }
          this.courseTalkTable.dataList.sort(Sort);
          this.courseTalkTable.MaxArr = this.courseTalkTable.dataList[0];
        });
    },

    // 各类型资源存储量
    resourcesNumber() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getResourceCount, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.dataList.length; i++) {
            this.typeResources.dataList.push({
              name: res.data.transverseData[i],
              value: res.data.dataList[i],
            });
          }
          this.typeResources.sucai = this.typeResources.dataList.find(
            (item) => item.name == "素材资源"
          );
          this.typeResources.rongliang = this.typeResources.dataList.find(
            (item) => item.name == "资源存储量"
          );
        });
    },
    // 资源类型占比
    resourcesProportion() {
      this.$axios
        .post(this.$apiurls.materialResources_getAllResourceCount, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.name.length; i++) {
              this.educationLevel.total += res.data.value[i];
              this.educationLevel.dataList.push({
                name: res.data.name[i],
                value: res.data.value[i],
              });
            }

            // let datas = []
            // datas = this.educationLevel.dataList.filter(item => item.name != '其他')
            // this.educationLevel.dataList = datas

            function Sort(a, b) {
              return a.value - b.value;
            }
            this.educationLevel.dataList.sort(Sort);

            this.educationLevel.Max = this.educationLevel.dataList[0];

            this.educationLevel.video = this.educationLevel.dataList.find(
              (item) => item.name == "视频"
            );
            this.educationLevel.dataList.forEach((item) => {
              this.educationLevel.transverseData.push(item.name);
            });
            this.educationLevel.xuni = this.educationLevel.dataList.find(
              (item) => item.name == "虚拟仿真"
            );
          }
        });
    },

    // 资源被访问量排名（前十五名）
    resourceTableHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportResourceRank, {
          loading: false,
        })
        .then((res) => {
          this.resourceTable.dataList = res.data.resourceRank;
          this.resourceTable.resourceTotal = res.data.resourceTotal;
          this.resourceTable.resourceAvg = res.data.resourceAvg;
          this.resourceTable.MaxArr = this.resourceTable.dataList;

          function Sort(a, b) {
            return b.num - a.num;
          }
          this.resourceTable.MaxArr.sort(Sort);
          this.resourceTable.Max = this.resourceTable.MaxArr[0];

          this.resourceTable.dataList.forEach((item) => {
            let index = item.name.indexOf(",") + 1;
            let type = item.name.slice(index);
            let name = item.name.slice(0, index - 1);
            this.$set(item, "resourceType", type);
            this.$set(item, "name", name);
          });

          let datasMax = this.educationLevel.Max;
          datasMax.name = datasMax.name + "类";

          let some = this.resourceTable.dataList.find((item) => item.resourceType == datasMax.name);
          this.resourceTable.MaxZykname = some;
        });
    },

    // 1.2.2 各省课程建设及应用
    // 获取省份用户数排名（前十五）
    getuser() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportProvinceUserRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.getUser.dataList = res.data.value;
            this.getUser.legendList = res.data.name;
            let datas = [];
            for (let i = 0; i < this.getUser.dataList.length; i++) {
              this.getUser.total += this.getUser.dataList[i];
              datas.push({ name: this.getUser.legendList[i], value: this.getUser.dataList[i] });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.getUser.sortMax = datas;
            this.getUser.MaxArr = this.getUser.sortMax[0];
          }
        });
    },

    // 各省在线学习人数排名（前十五）
    provinceStudyNum() {
      this.$axios
        .post(this.$apiurls.overview_getOnlineStudyUserNumRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.provinceStudy.dataList = res.data.value;
            this.provinceStudy.legendList = res.data.name;
            let datas = [];
            for (let i = 0; i < this.provinceStudy.dataList.length; i++) {
              this.provinceStudy.total += this.provinceStudy.dataList[i];
              datas.push({
                name: this.provinceStudy.legendList[i],
                value: this.provinceStudy.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.provinceStudy.sortMax = datas;
            this.provinceStudy.MaxArr = this.provinceStudy.sortMax[0];
          }
        });
    },

    // 各省交流互动量排名（前十五名）
    provinceTalk() {
      this.$axios
        .post(this.$apiurls.overview_getInteractionNumRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.provinceTalking.dataList = res.data.value;
            this.provinceTalking.legendList = res.data.name;
            let datas = [];
            for (let i = 0; i < this.provinceTalking.dataList.length; i++) {
              this.provinceTalking.total += this.provinceTalking.dataList[i];
              datas.push({
                name: this.provinceTalking.legendList[i],
                value: this.provinceTalking.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.provinceTalking.sortMax = datas;
            this.provinceTalking.MaxArr = this.provinceTalking.sortMax[0];
            this.provinceTalking.SecArr = this.provinceTalking.sortMax[1];
          }
        });
    },

    // 课程数量分布
    curriculumNum() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getSchoolCourseProvinceRanking, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.curriculum.dataList = res.data.dataList;
            this.curriculum.legendList = res.data.transverseData;
            let datas = [];
            for (let i = 0; i < this.curriculum.dataList.length; i++) {
              this.curriculum.total += this.curriculum.dataList[i];
              datas.push({
                name: this.curriculum.legendList[i],
                value: this.curriculum.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.curriculum.sortMax = datas;
            this.curriculum.MaxArr = this.curriculum.sortMax[0];
          }
        });
    },

    // 获取省份教师数排名前15
    teacherNumType() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportProvinceTeacherRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.teacherProvince.dataList = res.data.value;
            this.teacherProvince.legendList = res.data.name;
            let datas = [];
            for (let i = 0; i < this.teacherProvince.dataList.length; i++) {
              this.teacherProvince.total += this.teacherProvince.dataList[i];
              datas.push({
                name: this.teacherProvince.legendList[i],
                value: this.teacherProvince.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.teacherProvince.sortMax = datas;
            this.teacherProvince.MaxArr = this.teacherProvince.sortMax[0];
          }
        });
    },

    // 各省建设资源数排名
    sourceMaterial() {
      this.$axios
        .post(this.$apiurls.professional_getResourceRanking, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.length; i++) {
              this.sourceMater.legendList.push(res.data[i].province);
              this.sourceMater.dataList.push(res.data[i].num);
              this.sourceMater.total += this.sourceMater.dataList[i];
            }

            // 数组排序
            function Sort(a, b) {
              return b.num - a.num;
            }
            res.data.sort(Sort);
            this.sourceMater.sortMax = res.data;
            this.sourceMater.MaxArr = this.sourceMater.sortMax[0];
          }
        });
    },

    // 各省资源访问数排名前15
    visitProvinceHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportProvinceResourceRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.visitProvince.dataList = res.data.value;
            this.visitProvince.legendList = res.data.name;

            let datas = [];
            for (let i = 0; i < this.visitProvince.dataList.length; i++) {
              this.visitProvince.total += this.visitProvince.dataList[i];
              datas.push({
                name: this.visitProvince.legendList[i],
                value: this.visitProvince.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.visitProvince.sortMax = datas;
            this.visitProvince.MaxArr = this.visitProvince.sortMax[0];
          }
        });
    },

    // 每月新增用户数
    userAddHanderl() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportUserMonthNew,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          //  图13
          this.userAdd.transverse = res.data.enterprise.name;
          this.userAdd.dataList1.push(res.data.student.value, res.data.teacher.value);
          this.userAdd.dataList2.push(res.data.enterprise.value, res.data.social.value);
          this.userAdd.tran = [];
          this.userAdd.tran.push("社会学习者", "企业用户");
          this.userAdd.colorList = this.colorList;
          let studentV = this.userAdd.dataList1[0];
          let teacherV = this.userAdd.dataList1[1];
          // 图 31
          this.userAdd.sAtdatas.push(studentV, teacherV);

          let enterpriseV = this.userAdd.dataList2[0];
          let socialV = this.userAdd.dataList2[1];

          let totalS = 0;
          let totalT = 0;
          let totalE = 0;
          let totalV = 0;

          studentV.forEach((item) => {
            this.userAdd.Stotal += item;
          });
          teacherV.forEach((item) => {
            this.userAdd.Ttotal += item;
          });

          enterpriseV.forEach((item) => {
            totalE += item;
          });

          socialV.forEach((item) => {
            totalV += item;
          });
          this.userAdd.total = this.userAdd.Stotal + this.userAdd.Ttotal + totalE + totalV;
        });
    },

    // 用户访问量趋势
    userTimeTalkHanderl() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportUserMonthVisitsRange,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.userTimeTalk.dataList = res.data.value;
            let total = 0;
            res.data.value.forEach((item) => {
              total += item;
            });
            this.userTimeTalk.dataList.forEach((item) => {
              this.userTimeTalk.total += item;
            });
            this.userTimeTalk.transverse = res.data.name;
          }
        });
    },
    // 新增课程数
    courseNewHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportMonthRange,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            // 新增课程数
            this.courseNew.dataList = res.data.courseNew.value;
            this.courseNew.transverse = res.data.courseNew.name;
            this.courseNew.dataList.forEach((item) => {
              this.courseNew.total += item;
            });

            // 新增课程趋势
            this.courseTrend.dataList = res.data.courseVisits.value;
            this.courseTrend.transverse = res.data.courseVisits.name;
            this.courseTrend.dataList.forEach((item) => {
              this.courseTrend.total += item;
            });

            // 新增资源数
            this.resourceNew.dataList = res.data.resourceNew.value;
            this.resourceNew.transverse = res.data.resourceNew.name;
            this.resourceNew.dataList.forEach((item) => {
              this.resourceNew.total += item;
            });

            // 性能增资源趋势
            this.resourceVisits.dataList = res.data.resourceVisits.value;
            this.resourceVisits.transverse = res.data.resourceVisits.name;
            this.resourceVisits.dataList.forEach((item) => {
              this.resourceVisits.total += item;
            });
          }
        });
    },
    // 新增课程趋势
    // courseTrendHandler() {
    //   this.$axios.post(this.$apiurls.provinceReport_getCountryReportMonthRange, { endDay: this.endDay, startDay: this.startDay }, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.courseTrend.dataList = res.data.courseVisits.value
    //       this.courseTrend.transverse = res.data.courseVisits.name
    //       this.courseTrend.dataList.forEach((item) => {
    //         this.courseTrend.total += item
    //       })
    //     }
    //   })
    // },
    // 新增课程数
    // resourceNewHandler() {
    //   this.$axios.post(this.$apiurls.provinceReport_getCountryReportMonthRange, { endDay: this.endDay, startDay: this.startDay }, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.resourceNew.dataList = res.data.resourceNew.value
    //       this.resourceNew.transverse = res.data.resourceNew.name
    //       this.resourceNew.dataList.forEach((item) => {
    //         this.resourceNew.total += item
    //       })
    //     }
    //   })
    // },
    // 新增课程趋势
    // resourceVisitsHandler() {
    //   this.$axios.post(this.$apiurls.provinceReport_getCountryReportMonthRange, { endDay: this.endDay, startDay: this.startDay }, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.resourceVisits.dataList = res.data.resourceVisits.value
    //       this.resourceVisits.transverse = res.data.resourceVisits.name
    //       this.resourceVisits.dataList.forEach((item) => {
    //         this.resourceVisits.total += item
    //       })
    //     }
    //   })
    // },

    // 监测云图_各等级资源库数量
    resourceLevelHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getResourceBaseLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.resourceLevel.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }
            this.resourceLevel.total = this.resourceLevel.dataList.find(
              (item) => item.name == "资源库总数"
            ).value;
            this.resourceLevel.countryNum = this.resourceLevel.dataList.find(
              (item) => item.name == "国家级"
            );
            this.resourceLevel.provinceNum = this.resourceLevel.dataList.find(
              (item) => item.name == "省市级"
            );
            this.resourceLevel.schoolNum = this.resourceLevel.dataList.find(
              (item) => item.name == "院校级"
            );
          }
        });
    },

    // 用户建设及应用情况
    userConstructionHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getCoreIndicators, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.userConstruction.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }

            this.userConstruction.userData = this.userConstruction.dataList.filter(
              (item) => item.name != "标准化课程"
            );
            this.userConstruction.userData = this.userConstruction.dataList.filter(
              (item) => item.name != "参建院校"
            );

            this.userConstruction.userData.find((item) => item.name == "学生");
            this.userConstruction.userData.find((item) => item.name == "教师");

            this.userConstruction.tearchNum = this.userConstruction.userData.find(
              (item) => item.name == "教师"
            );
            this.userConstruction.socialNum = this.userConstruction.userData.find(
              (item) => item.name == "社会学习者"
            );
            this.userConstruction.studentNum = this.userConstruction.userData.find(
              (item) => item.name == "学生"
            );
            this.userConstruction.EnterpriseNum = this.userConstruction.userData.find(
              (item) => item.name == "企业用户"
            );

            let newArr = [];
            newArr.push(
              this.userConstruction.tearchNum,
              this.userConstruction.socialNum,
              this.userConstruction.studentNum,
              this.userConstruction.EnterpriseNum
            );

            newArr.forEach((item) => {
              this.userConstruction.total += item.value;
            });

            this.userConstruction.standardcourse = this.userConstruction.dataList.find(
              (item) => item.name == "标准化课程"
            );

            this.userConstruction.userTotal =
              this.userConstruction.tearchNum.value +
              this.userConstruction.socialNum.value +
              this.userConstruction.studentNum.value +
              this.userConstruction.EnterpriseNum.value;
          }
        });
    },

    // 获取访问总体情况
    talkAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportTotalLogModule, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.talkAll.resource = res.data.resource;
            this.talkAll.course = res.data.course;
            this.talkAll.user = res.data.user;
          }
        });
    },

    // 学生类型整体情况
    studentConstructionHandler() {
      this.$axios
        .post(this.$apiurls.userPortrait_getSumStudentTypeEchart, {
          loading: false,
        })
        .then((res) => {
          console.log(res);
          if (res) {
            this.studentConstruction.dataList = res.data.map((item) => {
              let name = item.name;
              let value = item.value;
              return {
                name,
                value,
              };
            });
          }
        });
    },

    // 近一年社会学习者和企业用户访问情况
    socialAenterpriseHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserMonthVisits, {
          loading: false,
        })
        .then((res) => {
          let datas1 = [];
          let datas2 = [];
          res.data.enterprise.forEach((item) => {
            datas1.push(item.value);
          });
          res.data.social.forEach((item) => {
            datas2.push(item.value);
          });
          this.socialAndenterprise.dataList.push(datas1, datas2);
          this.socialAndenterprise.transverse = res.data.student.name;
        });
    },

    // 课程画像-课程数量图
    getcourseHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getSumCourseTypeCountEchart, {
          loading: false,
        })
        .then((res) => {
          this.getcourse.Standardization = res.data.find((item) => item.name == "标准化课程");
          this.getcourse.individualization = res.data.find((item) => item.name == "个性化课程");

          this.getcourse.dataList = res.data.map((item, index) => {
            let name = item.name;
            let value = item.value;
            return {
              name,
              value,
            };
          });
          this.getcourse.total = res.data[0].value + res.data[1].value;

          this.getcourse.dataList.forEach((item) => {
            this.getcourse.transverseData.push(item.name);
          });
        });
    },
    // 课程整体情况
    courseAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseState, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseDataAll.name = res.data.name;
            this.courseDataAll.zykDiv = res.data.zykDiv;
            this.courseDataAll.zykName = res.data.zykName;
          }
        });
    },
    // 获取专业大类
    getmajorHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykProfession, {
          loading: false,
        })
        .then((res) => {
          function Sort(a, b) {
            return b.value - a.value;
          }
          res.data = res.data.sort(Sort);
          this.getmajor.dataList = res.data;

          this.getmajor.MaxArr = res.data[0];
          this.getmajor.Second = res.data[1];

          res.data.forEach((item) => {
            this.getmajor.total += item.value;
          });
        });
    },

    // 资源库访问量排名
    getzykHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykLogRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykTable.dataList = res.data;
          this.getzykTable.FristArr = res.data[0];
          this.getzykTable.SecArr = res.data[1];
          this.getzykTable.ThrArr = res.data[2];

          let datas = res.data.map((item) => {
            let value = item.logNum;
            let name = item.zykName;
            return {
              value,
              name,
            };
          });

          function Sort(a, b) {
            return b.value - a.value;
          }
          datas.sort(Sort);
          datas.forEach((item) => {
            this.getzykTable.datas.push(item.value);
            this.getzykTable.transverseData.push(item.name);
          });
        });
    },

    getzykACtiveHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykACtive.colorList = this.colorList;
          res.data.forEach((item) => {
            this.getzykACtive.dataList.push(item.value);
            this.getzykACtive.transverseData.push(item.name);
          });
          this.getzykACtive.Frist = res.data[0];
          this.getzykACtive.Second = res.data[1];
          this.getzykACtive.Thrid = res.data[2];
        });
    },

    // 各省用户建设及应用
    getuserProHandeler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykUserProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          let datas = res.data.activeUser;

          function Sort(a, b) {
            return b.num - a.num;
          }
          datas.sort(Sort);

          this.userProvince.from = res.data.form;
          this.userProvince.studentUser = res.data.studentUser;
          this.userProvince.dataList = res.data.activeUser;

          res.data.activeUser.forEach((item) => {
            this.userProvince.total += item.num;
            this.userProvince.talkTotal += item.formun;
            this.userProvince.studyTotal += item.activeNum;
          });

          this.userProvince.MaxArr = res.data.studentUser;
          // this.userProvince.mapdatas = res.data.provinceLog.map(item => {

          //   let name = item.name
          //   let value = item.value
          //   return {
          //     name,
          //     value,
          //   }
          // })
          res.data.provinceLog.push(
            {
              name: "西藏",
              value: 0,
            },
            {
              name: "台湾",
              value: 0,
            },
            {
              name: "香港",
              value: 0,
            },
            {
              name: "青海",
              value: 0,
            },
            {
              name: "澳门",
              value: 0,
            }
          );
          this.userProvince.mapdatas = res.data.provinceLog;

          console.log(this.userProvince.mapdatas, "sssssssssssssss");

          let onilneStudy = this.userProvince.dataList;
          function Sort(a, b) {
            return b.activeNum - a.activeNum;
          }
          onilneStudy.sort(Sort);
          this.userProvince.onilneMax = onilneStudy[0];
        });
    },
    // 资源库课程介绍
    curriculProvinceHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.curriculProvince.dataList = res.data.courseRank;
          this.curriculProvince.MaxArr = this.curriculProvince.dataList[0];
          this.curriculProvince.SerArr = this.curriculProvince.dataList[1];

          res.data.courseRank.forEach((item) => {
            this.curriculProvince.total += item.num;
            this.curriculProvince.stotal += item.snum;
            this.curriculProvince.ptotal += item.pnum;
          });
          res.data.standard = this.curriculProvince.dataList.find((item) => item.name == "湖南省");
          this.curriculProvince.standard = res.data.standard;

          res.data.personality = this.curriculProvince.dataList.find(
            (item) => item.name == "广东省"
          );
          this.curriculProvince.personality = res.data.personality;
        });
    },

    // 资源库省份资源建设情况
    disksNumHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKResourceProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.disksNum.maxProvince = res.data.maxProvince;
          this.disksNum.dataList = res.data.provinceRank;

          this.disksNum.MaxArr = this.disksNum.dataList[0];
          this.disksNum.dataList.forEach((item) => {
            this.disksNum.total += item.log;
            this.disksNum.totalLog += item.count;
          });

          this.disksNum.buildMaxArr = this.disksNum.dataList;

          // function Sort(a, b) {
          //   return b.count - a.count
          // }

          // this.disksNum.buildMaxArr.sort(Sort)
          this.disksNum.buildMax = res.data.maxProvince;
        });
    },

    // 资源库用户运行情况
    zykuserYunHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKUserActiveStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 累计活跃用户
          // （1）资源库用户月活情况分析
          this.zykuserYun.userActiveTotal = res.data.userActiveTotal;
          let datas1 = [];
          let datas2 = [];
          res.data.userActiveMonth.forEach((item) => {
            datas1.push(item.value);
            datas2.push(item.name);
            this.zykuserYun.userActiveTotals += item.value;
          });

          this.zykuserYun.userActiveData = datas1;
          this.zykuserYun.userActiveTranserve = datas2;

          // （2）资源库用户访问情况分析
          // 标题数据统计
          res.data.userActive.forEach((item) => {
            this.zykuserYun.userActivelogNum += item.logNum;
          });
          // 创建一个新数组
          let newRoleArr = res.data.userActive.map((item) => {
            let num = item.num;
            let logNum = item.logNum;
            let role = item.role;
            return {
              num,
              logNum,
              role,
            };
          });

          // 单独的每位用户数组
          this.zykuserYun.roleStudent = newRoleArr.find((item) => item.role == "学生");
          this.zykuserYun.roleTeacher = newRoleArr.find((item) => item.role == "教师");
          this.zykuserYun.roleEnterprise = newRoleArr.find((item) => item.role == "企业用户");
          this.zykuserYun.roleSocial = newRoleArr.find((item) => item.role == "社会学习者");

          this.zykuserYun.userActiveRoleData = res.data.userActiveMonthRole.dataList;
          this.zykuserYun.userActiveRoleTranserve = res.data.userActiveMonthRole.transverseData;
          this.zykuserYun.userActiveRolelegendList = res.data.userActiveMonthRole.legendList;
          this.zykuserYun.colorList = this.colorList;
        });
    },
    // 资源库被用户访问情况排名分析
    fristAlast() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKVisitsRank,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userTop.fristTop15 = res.data.slice(0, 15);
          this.userTop.fristMax = this.userTop.fristTop15[0];

          this.userTop.last15 = res.data.slice(-15);
          this.userTop.lastMax = this.userTop.last15[this.userTop.last15.length - 1];
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.userTop.last15.sort(Sort);
        });
    },

    // 资源库资源运行情况
    zyktalkHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKResourceStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zyktalk.total = res.data.total;
          this.zyktalk.totalLog = res.data.totalLog;
          this.zyktalk.newRank = res.data.newRank;
          this.zyktalk.logRank = res.data.logRank;

          function Sort(a, b) {
            return b.num - a.num;
          }

          this.zyktalk.logRank.sort(Sort);
          this.zyktalk.MaxArr = this.zyktalk.logRank[0];
        });
    },

    ByLevelHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByLevel, 1, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.ByLevel.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
            this.ByLevel.total += res.data.value[i];
          }
          this.ByLevel.FristArr = this.ByLevel.dataList[0];
          this.ByLevel.SecArr = this.ByLevel.dataList[1];
          this.ByLevel.ThrArr = this.ByLevel.dataList[2];
          this.ByLevel.FouArr = this.ByLevel.dataList[3];
        });
    },

    PlatformHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 1, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.Platform.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.Platform.Plat = this.Platform.dataList.find((item) => item.name == "平台数");
        });
    },

    catorStatHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCoreIndicatorStat, 1, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.catorStat.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.catorStat.datas1 = this.catorStat.dataList.find((item) => item.name == "参建院校");
          this.catorStat.datas2 = this.catorStat.dataList.find(
            (item) => item.name == "教师参建人次"
          );
          this.catorStat.datas3 = this.catorStat.dataList.find((item) => item.name == "总访问量");
          this.catorStat.datas4 = this.catorStat.dataList.find((item) => item.name == "总开课期数");
          this.catorStat.datas5 = this.catorStat.dataList.find((item) => item.name == "总课时数");
          this.catorStat.datas6 = this.catorStat.dataList.find((item) => item.name == "总选课人数");
          this.catorStat.datas7 = this.catorStat.dataList.find(
            (item) => item.name == "累计互动次数"
          );
        });
    },

    // 在线精品课_参加课程数量各省排名
    courseProvinceRank() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseProvinceRank, 1, {
          loading: false,
        })
        .then((res) => {
          this.couseRank.dataList = res.data;

          function Sort(a, b) {
            return b.studynum - a.studynum;
          }

          this.couseRank.dataList.sort(Sort);

          this.couseRank.MaxArr = this.couseRank.dataList[0];
          this.couseRank.dataList.forEach((item) => {
            this.couseRank.total += item.studynum;
          });
        });
    },

    // 课程总访问量排名
    courseAlltalk() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseVisitRank,
          { statType: 1, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.couseAll.dataList = res.data;
          this.couseAll.MaxArr = this.couseAll.dataList[0];
          this.couseAll.dataList.forEach((item) => {
            this.couseAll.total += item.num;
          });
        });
    },

    // 课程开课期数
    couseOpenHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCourseSemesterRank,
          { statType: 1, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.couseOpen.dataList = res.data;
          this.couseOpen.MaxArr = this.couseOpen.dataList[0];
          this.couseOpen.total = res.total;
        });
    },
    // 课程选课人次排名
    courseSelection() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseStudyRank,
          { statType: 1, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseSelect.dataList = res.data;
          this.courseSelect.MaxArr = this.courseSelect.dataList[0];
          this.courseSelect.dataList.forEach((item) => {
            this.courseSelect.total += item.num;
          });
        });
    },

    // 第四部分
    ByLevelcourseVideo() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByLevel, 2, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.courseVideo.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.courseVideo.datas1 = this.courseVideo.dataList[0];
          this.courseVideo.datas2 = this.courseVideo.dataList[1];
          this.courseVideo.datas3 = this.courseVideo.dataList[2];
          this.courseVideo.datas4 = this.courseVideo.dataList[3];
          this.courseVideo.datas5 = this.courseVideo.dataList[4];
        });
    },

    PlatformVideoHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 2, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.name.length; i++) {
            this.courseVideo2.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.courseVideo2.ploaNum = this.courseVideo2.dataList.find(
            (item) => item.name == "平台数"
          );
        });
    },

    catorStatVideoHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCoreIndicatorStat, 2, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.name.length; i++) {
            this.courseVideo3.dataList.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.courseVideo3.datas1 = this.courseVideo3.dataList[2];
          this.courseVideo3.datas2 = this.courseVideo3.dataList[1];
          this.courseVideo3.datas3 = this.courseVideo3.dataList[0];
          this.courseVideo3.datas4 = this.courseVideo3.dataList[3];
          this.courseVideo3.datas5 = this.courseVideo3.dataList[4];
          this.courseVideo3.datas6 = this.courseVideo3.dataList[5];
          this.courseVideo3.datas7 = this.courseVideo3.dataList[6];
          this.courseVideo3.datas8 = this.courseVideo3.dataList[7];
        });
    },

    courseTopHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseProvinceRank, 2, {
          loading: false,
        })
        .then((res) => {
          this.courseTop.dataList = res.data;
          this.courseTop.MaxArr = this.courseTop.dataList[0];
          for (let i = 0; i < res.data.length; i++) {
            this.courseTop.total += res.data[i].studynum;
          }
        });
    },

    courseVideoPenHandler() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseVisitRank,
          { statType: 2, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseVideoPen.dataList = res.data;
          this.courseVideoPen.MaxArr = this.courseVideoPen.dataList[0];
          for (let i = 0; i < res.data.length; i++) {
            this.courseVideoPen.total += res.data[i].num;
          }
        });
    },

    courseVideoSelHandler() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseStudyRank,
          { statType: 2, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseVideoSel.dataList = res.data;
          this.courseVideoSel.MaxArr = this.courseVideoSel.dataList[0];

          this.courseVideoSel.dataList.forEach((item) => {
            this.courseVideoSel.total += item.num;
          });
        });
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  width: 85%;
  margin: 0px auto;
  height: 14500px;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 40px;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
  line-height: 51px;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
  margin: 100px 0px;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 40px;
  color: #1d244e;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}
.chart_box,
.catalogue h3 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 34px;
}
.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 35px;
  color: #1d244e;
  /*text-indent: 40px;*/
  /* line-height: 40px; */
  margin-bottom: 15px;
  margin-top: 34px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 38px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 34px;
}

.catalogue h5 {
  font-weight: 700;
  font-size: 30px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 34px;
}

.chart_box p {
  font-weight: 540 !important;
  font-size: 28px !important;
  text-indent: 2em;
  line-height: 60px;
  color: #272a3f !important;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 25px;
  color: #272a3f;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 33px;
  font-size: 22px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}
.biaoge {
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  line-height: 35px;
  color: #707f9d;
  font-size: 20px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}
::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  height: 2120px;
  padding-top: 20%;
  padding-left: 10%;
}

.HomePage #image {
  width: 700px;
  height: 150px;
  background: url("../../../../public/pdf.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin-top: 30%;
  padding: 30px 0px 10px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 55px;
  font-weight: 700;
  margin-bottom: 40px;
}

.HomePage #foot {
  flex-direction: column;
  display: flex;
  align-items: center;
  padding-left: 3.5%;
  font-size: 42px;
  position: absolute;
  bottom: 0%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  /* background: pink; */
  padding-top: 10%;
  padding-left: 5%;
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}
</style>
